webpackJsonp([2],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js__);





var aes = function () {
    function aes(args) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, aes);

        this.CryptoJSAesJson = {
            stringify: function stringify(cipherParams) {
                var j = { ct: cipherParams.ciphertext.toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Base64) };
                if (cipherParams.iv) j.iv = cipherParams.iv.toString();
                if (cipherParams.salt) j.s = cipherParams.salt.toString();
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(j);
            },
            parse: function parse(jsonStr) {
                var j = JSON.parse(jsonStr);
                var cipherParams = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.lib.CipherParams.create({ ciphertext: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Base64.parse(j.ct) });
                if (j.iv) cipherParams.iv = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(j.iv);
                if (j.s) cipherParams.salt = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(j.s);
                return cipherParams;
            }
        };
        this.CryptoJSAes = {
            stringify: function stringify(cipherParams) {
                var j = { ct: cipherParams.ciphertext.toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Base64) };
                if (cipherParams.iv) j.iv = cipherParams.iv.toString();
                if (cipherParams.salt) j.s = cipherParams.salt.toString();
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(j);
            },
            parse: function parse(jsonStr) {
                var j = JSON.parse(jsonStr);
                var cipherParams = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.lib.CipherParams.create({ ciphertext: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Base64.parse(j.ct) });
                if (j.iv) cipherParams.iv = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(j.iv);
                if (j.s) cipherParams.salt = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(j.s);
                return cipherParams;
            }
        };
        this.password = 'teraslapassword';
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(aes, [{
        key: 'encode',
        value: function encode(value) {
            return __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.encrypt(value.toString(), this.password, { format: this.CryptoJSAesJson }).toString();
        }
    }, {
        key: 'decode',
        value: function decode(value) {
            return __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.decrypt(value, 'teraslapassword', { format: this.CryptoJSAesJson }).toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Utf8);
        }
    }]);

    return aes;
}();

/* harmony default export */ __webpack_exports__["a"] = (new aes());

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(600),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(599),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(604),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(502)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(592),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  "data-v-dd99b7fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(598),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(601),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(597),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dbItem__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__teras__ = __webpack_require__(55);













var moment = __webpack_require__(0);
moment.locale('it');

var abs = function (_dbitem) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(abs, _dbitem);

  function abs(args) {
    var _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, abs);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (abs.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(abs)).call(this));

    _this.mysql.table = 'abstract';
    _this.teras = __WEBPACK_IMPORTED_MODULE_11__teras__["a" /* default */];
    _this.urlPreview = "#";
    _this.lineeguida = false;
    _this.inviato = false;
    return _ret = _this, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(abs, [{
    key: 'saveAutori',
    value: function saveAutori() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var autori = [];
        var num = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.teras.autori))), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var autore = _step.value;

            autore.primo = autore.id == _this2.row.pa ? 1 : 0;

            autore.abstract = _this2.row.id;
            autore.evento = _this2.row.evento;
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(autore.affiliazione));
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(autore.affiliazione) == 'object') autore.affiliazione = autore.affiliazione.join();
            autore.numero = num;
            autore.id = parseInt(_this2.row.id) * 1000 + num;
            if (autore.primo == 1) _this2.row.pa = autore.numero;
            num++;
            autori.push(autore);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        console.log(autori);
        _this2.axios.query('doQuery', 'DELETE FROM autore WHERE abstract=→abstract AND evento=→evento', { evento: _this2.row.evento, abstract: _this2.row.id }).then(function (data) {
          _this2.axios.insertRows(autori, 'autore').then(function (data) {
            _this2.axios.query('fetchAll', 'SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero', { evento: _this2.teras.evento.id, abstract: _this2.row.id }, _this2.teras, 'autori');
            _this2.axios.query('fetchOne', 'SELECT id FROM autore WHERE numero=→numero AND abstract=→abstract ', { numero: _this2.row.pa, abstract: _this2.row.id }, _this2.row, 'pa').then(function (data) {
              _this2.save().then(function (data) {
                resolve(true);
              });
            });
          });
        });
      });
    }
  }, {
    key: 'saveAffiliazioni',
    value: function saveAffiliazioni() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var affiliazioni = [];
        var num = 0;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this3.teras.affiliazioni))), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var affiliazione = _step2.value;

            affiliazione.abstract = _this3.row.id;
            affiliazione.evento = _this3.row.evento;
            affiliazione.numero = num;
            affiliazione.id = parseInt(_this3.row.id) * 1000 + num;
            num++;
            affiliazioni.push(affiliazione);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        console.log(affiliazioni);
        _this3.axios.query('doQuery', 'DELETE FROM affiliazione WHERE abstract=→abstract AND evento=→evento', { evento: _this3.row.evento, abstract: _this3.row.id }).then(function (data) {
          _this3.axios.insertRows(affiliazioni, 'affiliazione').then(function (data) {
            _this3.axios.query('fetchAll', 'SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero', { evento: _this3.row.evento, abstract: _this3.row.id }, _this3.teras, 'affiliazioni');
            resolve(true);
          });
        });
      });
    }
  }, {
    key: 'emailSend',
    value: function emailSend() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.row.step = 1;
        _this4.save().then(function (data) {
          var args = { idAbs: _this4.row.id, sendto: '', lingua: 'ita' };
          _this4.axios.post(_this4.axios.apiUrl + 'vue/soap', { url: 'http://tomcat:8080/j-bvent/services/Ws?wsdl', action: 'bamsEmailAbsInserito', args: args }).then(function (response) {
            console.log('RESPONSE EMAIL++++++++++++++++++++++++++++++++');
            console.log(response.data);
            resolve(true);
          });
        });
      });
    }
  }, {
    key: 'createPdf',
    value: function createPdf() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var args = { idAbs: _this5.row.id, idTemplate: _this5.teras.evento.template, lingua: 'ita', tipoFile: 'pdf', isPreview: 1 };
        _this5.axios.post(_this5.axios.apiUrl + 'vue/soap', { url: 'http://tomcat:8080/j-bvent/services/Ws?wsdl', action: 'bamsGeneraAbs', args: args }).then(function (response) {
          console.log('RESPONSE CREAPDF++++++++++++++++++++++++++++++++');
          console.log(response.data);
          _this5.urlPreview = _this5.teras.urlsite + response.data.data.result.altro.replace("https://bvent.biomedia.net/", "");
          resolve(true);
        });
      });
    }
  }, {
    key: 'nuovo',
    value: function nuovo() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.axios.query('doQuery', "DELETE FROM token WHERE  id=→id", { id: _this6.axios.sessionID }).then(function () {
          __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default()(abs.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(abs.prototype), 'new', _this6).call(_this6).then(function () {
            _this6.row.browsername = _this6.teras.browsername;
            _this6.row.browserversion = _this6.teras.browserversion;
            _this6.teras.minutes = 0;
            _this6.row.browsertime = _this6.teras.minutes;
            _this6.row.evento = _this6.teras.evento.id;
            if (_this6.teras.evento.poster == 2) _this6.row.poster = 1;
            _this6.lineeguida = false;
            _this6.urlPreview = "#";
            _this6.teras.affiliazioni = [];
            _this6.teras.autori = [];
            resolve(true);
          });
        });
      });
    }
  }, {
    key: 'send',
    value: function send() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.codice();
        __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default()(abs.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(abs.prototype), 'save', _this7).call(_this7).then(function (response) {
          _this7.saveAutori().then(function (response) {
            _this7.saveAffiliazioni().then(function (response) {
              _this7.emailSend().then(function (response) {
                _this7.createPdf().then(function (response) {
                  _this7.row.inseritoil = moment().format('YYYY-MM-DD HH:mm:00');
                  _this7.save().then(function (data) {
                    _this7.inviato = true;
                    _this7.nuovo().then(function () {
                      resolve(true);
                    });
                  });
                });
              });
            });
          });
        });
      });
    }
  }, {
    key: 'codice',
    value: function codice() {
      if (this.row.codice == '') this.row.codice = parseInt(this.teras.evento.bvent) * 100000 + parseInt(this.row.id);
    }
  }, {
    key: 'sendnoemail',
    value: function sendnoemail() {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this8.row.step = 1;
        _this8.codice();
        __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default()(abs.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(abs.prototype), 'save', _this8).call(_this8).then(function (response) {
          _this8.saveAutori().then(function (response) {
            _this8.saveAffiliazioni().then(function (response) {
              _this8.createPdf().then(function (response) {
                _this8.save().then(function (data) {
                  _this8.inviato = true;
                  _this8.nuovo().then(function () {
                    resolve(true);
                  });
                });
              });
            });
          });
        });
      });
    }
  }, {
    key: 'preview',
    value: function preview() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default()(abs.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(abs.prototype), 'save', _this9).call(_this9).then(function (response) {
          _this9.row.token = _this9.aes.encode(_this9.row.id);
          __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_get___default()(abs.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(abs.prototype), 'save', _this9).call(_this9);
          _this9.axios.query('doQuery', "REPLACE INTO token VALUES (→id,←abstract)", { id: _this9.axios.sessionID, abstract: _this9.row.id });
          _this9.saveAutori().then(function (response) {
            _this9.saveAffiliazioni().then(function (response) {
              _this9.createPdf().then(function (response) {
                resolve(true);
              });
            });
          });
        });
      });
    }
  }]);

  return abs;
}(__WEBPACK_IMPORTED_MODULE_10__dbItem__["a" /* dbitem */]);

/* harmony default export */ __webpack_exports__["a"] = (new abs());

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    si: 'Yes',
    no: 'No',
    errore: 'Error',
    modifica: 'Edit',
    salvainvia: 'Save and send',
    warning: 'WARNING',
    aggiungi: 'Add',
    salvamodifiche: 'Save',
    cancella: 'Cancel',
    esito: 'status of abstract',

    testo: 'Text',
    titolo: 'Title',
    parolechiave: 'Keywords',
    parolechiaveHolder: "Text 3 or more keywords",
    cognome: 'surname',
    nome: 'name',
    email: 'email',
    cellulare: 'Mobile Phone',
    affiliazione: 'Affiliation',
    scegliere_lista: 'Choose from list',
    scegliere_topic: 'Choose topic from list',
    codiceconsultazione: 'consultation code ',
    codicefiscale: 'Fiscal Code',
    socio: 'Member',
    nazionelavoro: 'Working State',
    regionelavoro: 'Working Region',
    categoriaprofessionale: 'Profession',
    annonascita: 'Year of birth',
    allegato: 'Image to attach',

    assistenzaSection: 'ASSISTENCE',
    assistenzaHelp: 'For further assistence, please contact:',

    lineeguidaSection: 'GuideLines',
    lineeguidaCheck: ' I saw the guidelines and I accept to send the abstract',

    datipresentatoreSection: 'PRESENTER INFORMATION',
    datipresentatoreHelp: 'The presenter is the contact person for the communication of the abstract',

    affiliazioniSection: 'AFFILIATIONS',
    affiliazioniHelp: 'Write in lower case with uppercase initials without pointing the street (i.e. Clinical Biochemistry Lab, Osp. Fatebenefratelli, Milan)\n    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">The same affiliation must be used just once</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">Use one line for each affiliation</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">Use abbreviations (i.e. Dep.)</div></div>',
    affiliazioniOrderHelp: 'To change the order of affiliations just drag and place the affiliate position to the correct position \n    <br />\n    To change or delete any of the affiliates you have already inserted, click on the affiliate you want to edit, and proceed with the changes.',

    autoriSection: 'AUTHORS',
    autoriHelp: 'Write the full name with the first letter in capital\n    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">1</div><div class="col s11m">Write the name and surname of the first author</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">2</div><div class="col s11m">From the drop-down list, select the affiliate or the affiliations of reference from the ones previously inserted</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">3</div><div class="col s11m">Confirm your data with   <i class="el-icon-plus"></i> or if you are changing the data of an author already inserted with <i class="el-icon-edit"></i> </div></div>',
    autoriOrderHelp: 'To change the order of affiliations just drag and place the affiliate position to the correct position\n    <br />\n    To change or delete any of the affiliates you have already inserted, click on the affiliate you want to edit, and proceed with the changes.',

    paSection: 'FIRST AUTHOR',
    paName: 'First Author',

    datiabsSection: 'ABSTRACT INFORMATION',
    datiabsOrale: 'Do you want to submit your abstract as oral communication?',
    datiabsPoster: 'Do you want to submit your abstract as Poster?',
    datiabsPosterNoOrale: 'If your abstract will not be accepted as oral communication, do you want to submit it as a poster?',

    finanziamentiSection: 'FINANCE INFORMATION',
    finanziamentiLabel: "Abstract ha ricevuto finanziamenti? se si specificare quali",

    testoSection: 'TITLE AND TEXT',
    titoloolder: 'Text a title for abstract',
    maxparoleWarning: 'Exceeded the maximum number of words that is',

    datitestoHelp: 'Please consider that the platform allows you to copy and paste your abstract text but just in the case you have previously copied your text in the notepad programme (NOT directly from Word file).',

    previewSection: 'PREVIEW AND SEND',
    previewHelp: 'Click on PREVIEW to see you abstract.\n    <br />\n    Once you have check your abstract, please accept the preview .\n    <br />\n    Until you send the abstract this will not be valid.',
    previewCheck: 'I saw the preview',
    previewCheckHelp: 'To send your own abstract you must first tick the preview box and accept the preview.\n    <br />\n    If you want to make changes, press the "Edit" button',
    previewCheckedHelp: 'Congratulation,now you can send the abstract!',

    eRequired: {
        premail: 'email address of presenter is mandatory',
        prcognome: 'surname of presenter is mandatory',
        prnome: 'name of presenter is mandatory',
        paemail: 'email of the first author is mandatory',
        pacellulare: 'mobile phone of the first author is mandatory',
        pacodicefiscale: 'Fiscal Code Only for italian participants',
        panato: 'Year of birth of the first author is mandatory',
        pacategoriaprofessionale: 'Profession of the first author is mandatory',
        paregionelavoro: 'Working region of the first author is mandatory',
        panazionelavoro: 'Nationality of the first author is mandatory',
        paassociazione: 'Please flag if the first author is member or not member',
        poster: 'Poster is mandatory',
        topicposter: 'Topic for poster is mandatory',
        comunicazione: 'Oral communication is mandatory',
        topiccomunicazione: 'Topic for oral communication is mandatory',
        titolo: 'title is mandatory',
        parolechiave: 'Key words are mandatory',
        codiceconsultazione: 'consultation code is mandatory'
    },

    eEmail: 'email address is not correct',

    inviatoText: 'Congratulations! Your abstract has been sent',
    inviatoButton: 'Send another Abstract',

    privacyTitle: 'PRIVACY POLICY',
    privacyText: 'Please <a href="https://www.biomedia.net/gdpr/privacy-ABSTRACT-en.pdf">view</a> Privacy Policy'

});

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    si: 'Si',
    no: 'No',
    errore: 'Errore',
    modifica: 'Modifica',
    salvainvia: 'Salva ed Invia',
    warning: 'ATTENZIONE',
    aggiungi: 'Aggiungi',
    salvamodifiche: 'Salva le modifiche',
    cancella: 'Cancella',
    esito: 'Stato di consultazione',

    testo: 'testo',
    titolo: 'titolo',
    parolechiave: 'Parole Chiave',
    parolechiaveHolder: "Indicare le parole chiavi del proprio abstract",
    cognome: 'cognome',
    nome: 'nome',
    email: 'email',
    cellulare: 'cellulare',
    affiliazione: 'affiliazione',
    scegliere_lista: 'Scegliere dalla lista',
    scegliere_topic: 'Scegliere il topic tra quelli disponibili',
    codiceconsultazione: 'Codice di consultazione',
    codicefiscale: 'Codice Fiscale',
    socio: 'Socio',
    nazionelavoro: 'Nazione Lavoro',
    regionelavoro: 'Regione Lavoro',
    categoriaprofessionale: 'Categoria Professionale',
    annonascita: 'Anno di nascita',
    allegato: 'Immagine da allegare',

    assistenzaSection: 'ASSISTENZA',
    assistenzaHelp: 'Per ricevere assistenza potete contattare la referente di Biomedia:',

    lineeguidaSection: 'LINEE GUIDA',
    lineeguidaCheck: 'Ho letto e <b>compreso</b>, quindi accetto le linee guida per l\'invio del Abstract',

    datipresentatoreSection: 'CORRESPONDING AUTHOR',
    datipresentatoreHelp: '',

    affiliazioniSection: 'AFFILIAZIONI',
    affiliazioniHelp: 'Scrivere in minuscolo con iniziale maiuscola senza indicare la via (es. Lab. di Biochimica Clinica, Osp. Fatebenefratelli, Milano)\n    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">NON inserire pi\xF9 volte la stessa affiliazione</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">Utilizzare una sola riga per ogni affiliazione</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">Utilizzare sigle e abbreviazioni (es. Dip., Sez., Lab., U.O., Osp.)</div></div>',
    affiliazioniOrderHelp: 'Per cambiare l\'ordine delle affiliazioni basta trascinare e posizionare nella posizione corretta l\'affiliazione da cambiare \n    <br />\n    Per cambiare o cancellare una delle affiliazioni gi\xE0 inserite, cliccare sull\'affiliazione che si desidera modificare, e procedere con le modifiche. ',

    autoriSection: 'AUTORI',
    autoriHelp: 'Scrivere il nome per esteso con l\'iniziale maiuscola (es. Rossi Pier Luigi no Rossi P.L.)\n    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">1</div><div class="col s11m">Inserite il cognome e il nome dell\'autore</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">2</div><div class="col s11m">Dal men\xF9 a tendina selezionare l\'affiliazione o le affiliazioni di riferiemento fra quelle precedentemente inserite</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">3</div><div class="col s11m">Confermare i dati con <i class="el-icon-plus"></i> oppure se si sta modificando un autore precedentemente inserito con <i class="el-icon-edit"></i> </div></div>',
    autoriOrderHelp: 'Per cambiare l\'ordine degli autori basta trascinare e posizionare nella posizione corretta l\'autore da cambiare\n    <br />\n    Per cambiare o cancellare un autore gi\xE0 inserito, cliccare sull\'autore che si desidera modificare, e procedere con le modifiche.',

    paSection: 'PERSONA CHE PRESENTERA’ IL LAVORO AL CONVEGNO',
    paName: 'Primo Autore',

    datiabsSection: 'DATI ABSTRACT',
    datiabsOrale: 'Vuoi presentare l\u2019abstract come comunicazione orale?',
    datiabsPoster: 'Vuoi presentare l\u2019abstract come poster?',
    datiabsPosterNoOrale: 'Qualora l\u2019abstract non venisse accettato come comunicazione orale, lo vuole presentare come poster?',

    testoSection: 'TITOLO E TESTO',
    titoloolder: 'indicare il titolo per abstract',
    maxparoleWarning: 'Superato il numero masssimo di parole che \xE8 di',

    datitestoHelp: 'Se doveste avere problemi ad incollare il vostro testo dal programma MS word, vi consigliamo di passare dal blocco note prima di incollare nel gestionale.\n    <br />Potete anche provare ad incollare il testo con la combinazine di caratteri CTRL+SHIFT+v',

    previewSection: 'PREVIEW ED INVIO',
    previewHelp: 'Cliccare il pulsante preview per visionare il proprio absract.\n    <br />\n    Una volta verificato accettare la presa visione per poter inviare abstract.\n    <br />\n    Fino a quando non invierete l\'abstract questo non sar\xE0 valido.',
    previewCheck: 'Ho preso visione della preview',
    previewCheckHelp: 'Per inviare il proprio abstract bisogna prima spuntare il box di presa visione ed accettazione della preview.\n    <br />\n    Se invece si volessero apportare delle modifiche premere il pulsante "Modifica"',
    previewCheckedHelp: 'Complimenti ora pu\xF2 inviare l\'abstract!',

    eRequired: {
        premail: 'L\'email della persona di contatto è obbligatoria',
        prcognome: 'Il cognome della persona di contatto è obbligatorio',
        prnome: 'Il nome della persona di contatto è obbligatorio',
        paemail: 'L\'email del primo autore è obbligatoria',
        pacellulare: 'Il cellulare del primo autore è obbligatorio',
        pacodicefiscale: 'Il codicefiscale del primo autore è obbligatorio',
        panato: 'L\'anno di nascita del primo autore è obbligatorio',
        pacategoriaprofessionale: 'La categoria professionale del primo autore è obbligatorio',
        paregionelavoro: 'La regione del primo autore è obbligatorio',
        panazionelavoro: 'La nazione di lavoro del primo autore è obbligatorio',
        paassociazione: 'Indicare se si il primo autore sia socio o meno è obbligatorio',
        poster: 'La scelta se presentare abstract come Poster è obbligatoria',
        topicposter: 'La scelta del topic Poster è obbligatoria',
        comunicazione: 'La scelta se presentare abstract come comunicazione orale è obbligatoria',
        topiccomunicazione: 'La scelta del topic Comunicazione Orale è obbligatoria',
        titolo: 'Il titolo dell\'abstract è obbligatorio',
        parolechiave: 'Le parole chiave sono obbligatorie',
        codiceconsultazione: 'Il codice di consultazione è obbligatorio'
    },

    eEmail: 'Indirizzo email non corretto',

    inviatoText: 'Complimenti il suo abstract è stato inviato correttamente.',
    inviatoButton: 'Invia nuovo Abstract',

    privacyTitle: 'INFORMATIVA PRIVACY AI SENSI DELL\'ART. 13 REGOLAMENTO EUROPEO N. 679/2016',
    privacyText: 'Si prega di prendere visione dell\'Informativa sul Trattamento dei Dati <a href="https://www.biomedia.net/gdpr/privacy-ABSTRACT.pdf">cliccando qui</a>'

});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    si: 'Si',
    no: 'No',
    errore: 'Errore',
    modifica: 'Modifica',
    salvainvia: 'Salva ed Invia',
    warning: 'ATTENZIONE',
    aggiungi: 'Aggiungi',
    salvamodifiche: 'Salva le modifiche',
    cancella: 'Cancella',
    esito: 'Stato di consultazione',

    testo: 'testo',
    titolo: 'titolo',
    parolechiave: 'Parole Chiave',
    parolechiaveHolder: "Indicare le parole chiavi del proprio abstract",
    cognome: 'cognome',
    nome: 'nome',
    email: 'email',
    cellulare: 'cellulare',
    affiliazione: 'affiliazione',
    scegliere_lista: 'Scegliere dalla lista',
    scegliere_topic: 'Scegliere il topic tra quelli disponibili',
    codiceconsultazione: 'Codice di consultazione',
    codicefiscale: 'Codice Fiscale',
    socio: 'Socio',
    nazionelavoro: 'Nazione Lavoro',
    regionelavoro: 'Regione Lavoro',
    categoriaprofessionale: 'Categoria Professionale',
    annonascita: 'Anno di nascita',
    allegato: 'Immagine da allegare',

    assistenzaSection: 'ASSISTENZA',
    assistenzaHelp: 'Per ricevere assistenza potete contattare la referente di Biomedia:',

    lineeguidaSection: 'LINEE GUIDA',
    lineeguidaCheck: 'Ho letto e <b>compreso</b>, quindi accetto le linee guida per l\'invio del Abstract',

    datipresentatoreSection: 'DATI PERSONA DI CONTATTO',
    datipresentatoreHelp: 'La segreteria invierà le comunicazioni relative all\'abstract esclusivamente all\'indirizzo mail qui indicato.<br />La persona di contatto può non coincidere con il primo autore',

    affiliazioniSection: 'AFFILIAZIONI',
    affiliazioniHelp: 'Scrivere in minuscolo con iniziale maiuscola senza indicare la via (es. Lab. di Biochimica Clinica, Osp. Fatebenefratelli, Milano)\n    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">NON inserire pi\xF9 volte la stessa affiliazione</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">Utilizzare una sola riga per ogni affiliazione</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">\xBB</div><div class="col s11m">Utilizzare sigle e abbreviazioni (es. Dip., Sez., Lab., U.O., Osp.)</div></div>',
    affiliazioniOrderHelp: 'Per cambiare l\'ordine delle affiliazioni basta trascinare e posizionare nella posizione corretta l\'affiliazione da cambiare \n    <br />\n    Per cambiare o cancellare una delle affiliazioni gi\xE0 inserite, cliccare sull\'affiliazione che si desidera modificare, e procedere con le modifiche. ',

    autoriSection: 'AUTORI',
    autoriHelp: 'Scrivere il nome per esteso con l\'iniziale maiuscola (es. Rossi Pier Luigi no Rossi P.L.)\n    <div class="row pad" style="margin-top:16px;"><div class="col sm yo-align-right">1</div><div class="col s11m">Inserite il cognome e il nome dell\'autore</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">2</div><div class="col s11m">Dal men\xF9 a tendina selezionare l\'affiliazione o le affiliazioni di riferiemento fra quelle precedentemente inserite</div></div>\n    <div class="row pad"><div class="col sm yo-align-right">3</div><div class="col s11m">Confermare i dati con <i class="el-icon-plus"></i> oppure se si sta modificando un autore precedentemente inserito con <i class="el-icon-edit"></i> </div></div>',
    autoriOrderHelp: 'Per cambiare l\'ordine degli autori basta trascinare e posizionare nella posizione corretta l\'autore da cambiare\n    <br />\n    Per cambiare o cancellare un autore gi\xE0 inserito, cliccare sull\'autore che si desidera modificare, e procedere con le modifiche.',

    paSection: 'PRIMO AUTORE',
    paName: 'Primo Autore',

    datiabsSection: 'DATI ABSTRACT',
    datiabsOrale: 'Vuoi presentare l\u2019abstract come comunicazione orale?',
    datiabsPoster: 'Vuoi presentare l\u2019abstract come poster?',
    datiabsPosterNoOrale: 'Qualora l\u2019abstract non venisse accettato come comunicazione orale, lo vuole presentare come poster?',

    finanziamentiSection: 'FINANZIAMENTI',
    finanziamentiLabel: "Abstract ha ricevuto finanziamenti? se si specificare quali",

    testoSection: 'TITOLO E TESTO',
    titoloolder: 'indicare il titolo per abstract',
    maxparoleWarning: 'Superato il numero masssimo di parole che \xE8 di',

    datitestoHelp: 'Se doveste avere problemi ad incollare il vostro testo dal programma MS word, vi consigliamo di passare dal blocco note prima di incollare nel gestionale.\n    <br />Potete anche provare ad incollare il testo con la combinazine di caratteri CTRL+SHIFT+v',

    previewSection: 'PREVIEW ED INVIO',
    previewHelp: 'Cliccare il pulsante preview per visionare il proprio absract.\n    <br />\n    Una volta verificato accettare la presa visione per poter inviare abstract.\n    <br />\n    Fino a quando non invierete l\'abstract questo non sar\xE0 valido.',
    previewCheck: 'Ho preso visione della preview',
    previewCheckHelp: 'Per inviare il proprio abstract bisogna prima spuntare il box di presa visione ed accettazione della preview.\n    <br />\n    Se invece si volessero apportare delle modifiche premere il pulsante "Modifica"',
    previewCheckedHelp: 'Complimenti ora pu\xF2 inviare l\'abstract!',

    eRequired: {
        premail: 'L\'email della persona di contatto è obbligatoria',
        prcognome: 'Il cognome della persona di contatto è obbligatorio',
        prnome: 'Il nome della persona di contatto è obbligatorio',
        paemail: 'L\'email del primo autore è obbligatoria',
        pacellulare: 'Il cellulare del primo autore è obbligatorio',
        pacodicefiscale: 'Il codicefiscale del primo autore è obbligatorio',
        panato: 'L\'anno di nascita del primo autore è obbligatorio',
        pacategoriaprofessionale: 'La categoria professionale del primo autore è obbligatorio',
        paregionelavoro: 'La regione del primo autore è obbligatorio',
        panazionelavoro: 'La nazione di lavoro del primo autore è obbligatorio',
        paassociazione: 'Indicare se si il primo autore sia socio o meno è obbligatorio',
        poster: 'La scelta se presentare abstract come Poster è obbligatoria',
        topicposter: 'La scelta del topic Poster è obbligatoria',
        comunicazione: 'La scelta se presentare abstract come comunicazione orale è obbligatoria',
        topiccomunicazione: 'La scelta del topic Comunicazione Orale è obbligatoria',
        titolo: 'Il titolo dell\'abstract è obbligatorio',
        parolechiave: 'Le parole chiave sono obbligatorie',
        codiceconsultazione: 'Il codice di consultazione è obbligatorio'
    },

    eEmail: 'Indirizzo email non corretto',

    inviatoText: 'Complimenti il suo abstract è stato inviato correttamente.',
    inviatoButton: 'Invia nuovo Abstract',

    privacyTitle: 'INFORMATIVA PRIVACY AI SENSI DELL\'ART. 13 REGOLAMENTO EUROPEO N. 679/2016',
    privacyText: 'Si prega di prendere visione dell\'Informativa sul Trattamento dei Dati <a href="https://www.biomedia.net/gdpr/privacy-ABSTRACT.pdf">cliccando qui</a>'

});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

function load(name) {
  return __webpack_require__(622)("./" + name + '.vue');
}

var mode =  true ? 'history' : 'hash';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({

  mode: mode,
  base: '/bams/',

  routes: [{ path: '/', name: 'home' }, { path: '/abs-new', name: 'absNew', meta: { nav: true }, components: { main: load('Abs-new') } }, { path: '/inviato', name: 'inviato', meta: { nav: true }, components: { main: load('Inviato') } }, { path: '/chiuso', name: 'chiuso', meta: { nav: true }, components: { main: load('Chiuso') } }, { path: '/start/:evento', name: 'start' }, { path: '/startnodeadline/:evento', name: 'startnodeadline' }, { path: '/start/:evento/abs/:abstract', name: 'startAbs' }, { path: '/edit/:abstract/:premail', name: 'edit' }, { path: '/consulta', name: 'consulta', meta: { nav: true }, components: { main: load('Abs-consulta') } }, { path: '/startconsulta/:evento*', name: 'startconsulta' }]
}));

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Site_header_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Site_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Site_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Site_footer_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Site_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Site_footer_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    siteHeader: __WEBPACK_IMPORTED_MODULE_0__components_Site_header_vue___default.a,
    siteFooter: __WEBPACK_IMPORTED_MODULE_1__components_Site_footer_vue___default.a
  }
});

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-affiliazioni',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  created: function created() {
    console.log("Arrivo al abs-affiliazioni.vue");
  },
  data: function data() {
    return {
      options: {},
      affiliazione: {
        id: -1,
        nome: ''
      }
    };
  },

  methods: {
    onEnd: function onEnd() {},
    onEdit: function onEdit(affiliazione) {
      this.affiliazione.id = affiliazione.id;
      this.affiliazione.nome = affiliazione.nome;
    },
    delNow: function delNow() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.affiliazioni), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var affiliazione = _step.value;

          if (affiliazione.id == this.affiliazione.id) {
            console.log(this.$teras.affiliazioni.indexOf(affiliazione));
            this.$teras.affiliazioni.splice(this.$teras.affiliazioni.indexOf(affiliazione), 1);
            this.reset();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addNow: function addNow() {
      this.affiliazione.id = this.$teras.affiliazioni.length;
      this.$teras.affiliazioni.push({ id: this.affiliazione.id, cognome: this.affiliazione.cognome, nome: this.affiliazione.nome });
      this.reset();
    },
    editNow: function editNow() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.affiliazioni), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var affiliazione = _step2.value;

          if (affiliazione.id == this.affiliazione.id) {
            affiliazione.nome = this.affiliazione.nome;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.reset();
    },
    reset: function reset() {
      this.affiliazione.id = -1;
      this.affiliazione.nome = '';
    }
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-autori',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  created: function created() {
    console.log("Arrivo al abs-autori.vue");
  },
  data: function data() {
    return {
      options: {},
      autore: {
        id: -1,
        cognome: '',
        nome: '',
        affiliazione: []
      }
    };
  },

  computed: {},
  methods: {
    affiliazione: function affiliazione(ids) {
      var affiliazioni = [];
      console.log('AFFILIAZIONI ++++++++++++++++++++++++++++++++++++');
      console.log(typeof ids === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(ids));
      if ((typeof ids === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(ids)) === 'object') {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(ids), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var id = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {

              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.affiliazioni), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var affiliazione = _step2.value;

                if (affiliazione.id == id) {
                  affiliazioni.push(this.$teras.affiliazioni.indexOf(affiliazione) + 1);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }if (typeof ids === 'string') {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(ids.split(',')), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _affiliazione = _step3.value;

            affiliazioni.push(parseInt(_affiliazione) + 1);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }if (typeof ids === 'number') affiliazioni.push(parseInt(ids) + 1);

      return affiliazioni.join();
    },
    onEnd: function onEnd() {},
    onEdit: function onEdit(autore) {
      this.autore.id = autore.id;
      this.autore.cognome = autore.cognome;
      this.autore.nome = autore.nome;
      if (typeof autore.affiliazione === 'string') {
        this.autore.affiliazione = autore.affiliazione.split(',').map(Number);
        console.log(autore.affiliazione.split(',').map(Number));
      } else if (typeof autore.affiliazione === 'number') {
        this.autore.affiliazione = [autore.affiliazione];
      } else {
        this.autore.affiliazione = autore.affiliazione;
      }
      console.log("MODIFICO");
      console.log(autore);
      console.log(this.$teras.autori);
    },
    delNow: function delNow() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var autore = _step4.value;

          if (autore.id == this.autore.id) {
            console.log(this.$teras.autori.indexOf(autore));
            this.$teras.autori.splice(this.$teras.autori.indexOf(autore), 1);
            this.reset();
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    },
    addNow: function addNow() {
      this.autore.id = this.$teras.autori.length;
      this.$teras.autori.push({ id: this.autore.id, cognome: this.autore.cognome, nome: this.autore.nome, affiliazione: this.autore.affiliazione });
      this.reset();
      if (this.$teras.abs.pa = -1) {
        this.$teras.abs.pa = 0;
      }
    },
    editNow: function editNow() {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var autore = _step5.value;

          if (autore.id == this.autore.id) {
            autore.cognome = this.autore.cognome;
            autore.nome = this.autore.nome;
            autore.affiliazione = this.autore.affiliazione;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.reset();
    },
    reset: function reset() {
      this.autore.id = -1;
      this.autore.cognome = '';
      this.autore.nome = '';
      this.autore.affiliazione = [];
    }
  }
});

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rules: {
        codiceconsultazione: [{ required: true, message: this.$teras.lang.eRequired.codiceconsultazione, trigger: 'blur' }]
      },
      abs: {
        codiceconsultazione: ''
      },
      esito: false,
      html: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onConsulta: function onConsulta() {
      var _this = this;

      this.esito = false;
      this.html = '';

      this.$refs.isAbs.validate(function (valid) {
        if (valid) {
          var parent = _this;
          _this.axios.query('fetchRow', 'SELECT * FROM abstract WHERE codice= →codiceconsultazione', { codiceconsultazione: _this.abs.codiceconsultazione }).then(function (data) {
            console.log('§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§ù');
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.result));
            console.log(data.result);
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data.result) == 'object') {
              parent.getHtml(data.result.id);
            } else {
              parent.$notify.error({ title: 'Errore', message: 'Il tuo abstract non è stato trovato!' });
            }
          });
        } else {
          _this.$notify.error({ title: 'Errore', message: 'Non tutti i dati sono stati inseriti correttamente!' });
        }
      });
    },
    getHtml: function getHtml(id) {
      var _this2 = this;

      var args = { idAbs: id, sendto: '', lingua: 'ita' };
      this.axios.post(this.axios.apiUrl + 'vue/soap', { url: 'http://tomcat:8080/j-bvent/services/Ws?wsdl', action: 'bamsPaginaConsultazione', args: args }).then(function (response) {
        console.log('******************************RESPONSE');
        _this2.html = response.data.data.result.altro;
        _this2.esito = true;
        console.log(response.data.data.result.altro);
      }).catch(function (error) {
        console.log('ERRORE..............................');
        console.log(response);
      });
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page_tinymce_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page_tinymce_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Page_tinymce_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-primoautore',
  components: {
    tinymce: __WEBPACK_IMPORTED_MODULE_0__Page_tinymce_vue___default.a
  },
  data: function data() {
    return {
      finanziamenti: -1
    };
  },
  created: function created() {
    console.log("Arrivo al abs-testo.vue");
    if (this.$abs.row.finanziamenti != '') {
      this.finanziamenti = 1;
    } else {
      this.finanziamenti = 0;
    }
  },

  methods: {
    finanziamentiChange: function finanziamentiChange(new_value) {}
  }
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pdf_desktop_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pdf_desktop_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Pdf_desktop_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Abs_presentatore_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Abs_presentatore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Abs_presentatore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Abs_affiliazioni_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Abs_affiliazioni_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Abs_affiliazioni_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Abs_autori_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Abs_autori_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Abs_autori_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Abs_primoautore_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Abs_primoautore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Abs_primoautore_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Abs_poster_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Abs_poster_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Abs_poster_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Abs_testo_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Abs_testo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Abs_testo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Abs_finanziamenti_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Abs_finanziamenti_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Abs_finanziamenti_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuedraggable__);
















var moment = __webpack_require__(0);
moment.locale('it');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-news',
  components: {
    elPdf: __WEBPACK_IMPORTED_MODULE_2__Pdf_desktop_vue___default.a,
    absPresentatore: __WEBPACK_IMPORTED_MODULE_3__Abs_presentatore_vue___default.a,
    absAffiliazioni: __WEBPACK_IMPORTED_MODULE_4__Abs_affiliazioni_vue___default.a,
    absAutori: __WEBPACK_IMPORTED_MODULE_5__Abs_autori_vue___default.a,
    absPrimoautore: __WEBPACK_IMPORTED_MODULE_6__Abs_primoautore_vue___default.a,
    absPoster: __WEBPACK_IMPORTED_MODULE_7__Abs_poster_vue___default.a,
    absTesto: __WEBPACK_IMPORTED_MODULE_8__Abs_testo_vue___default.a,
    absFinanziamenti: __WEBPACK_IMPORTED_MODULE_9__Abs_finanziamenti_vue___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default.a
  },
  mounted: function mounted() {
    var parent = this;
  },
  destroyed: function destroyed() {
    clearInterval(this.timeBozza);
  },
  created: function created() {
    console.log("Arrivo al abs-new.vue");
    console.log(navigator);
    var parent = this;
  },
  data: function data() {
    return {
      timeBozza: null,
      urlPreview: '/abstracts/1/6.pdf',
      preview: false,

      autore: {
        id: -1,
        cognome: '',
        nome: '',
        affiliazione: ''
      },
      checkTelefono: function checkTelefono(rule, value, callback) {

        if (value.toString() == '') {
          alert('Inserire il numero');
          return callback(new Error('Inserire il numero'));
        } else {
          callback();
        }
      },

      checkAge: function checkAge(rule, value, callback) {
        if (!value) {
          return callback(new Error('Please input the age'));
        }
        setTimeout(function () {
          if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
            callback(new Error('Please input digits'));
          } else {
            if (value < 18) {
              callback(new Error('Age must be greater than 18'));
            } else {
              callback();
            }
          }
        }, 1000);
      },

      content: 'prova di messaggio'
    };
  },

  computed: {

    rules: function rules() {
      console.log(this.$teras.lang.eRequired);
      var rulesNow = {
        premail: [{ required: true, message: this.$teras.lang.eRequired.premail, trigger: 'blur' }, { type: 'email', message: this.$teras.lang.eEmail, trigger: 'blur,change' }],
        prcognome: [{ required: true, message: this.$teras.lang.eRequired.prcognome, trigger: 'blur' }],
        prnome: [{ required: true, message: this.$teras.lang.eRequired.prnome, trigger: 'blur' }],
        paemail: [{ required: true, message: this.$teras.lang.eRequired.paemail, trigger: 'blur' }, { type: 'email', message: this.$teras.lang.eEmail, trigger: 'blur,change' }],
        pacellulare: [{ required: true, validator: this.checkTelefono, message: this.$teras.lang.eRequired.pacellulare, trigger: 'blur' }],

        pacodicefiscale: [{ required: this.$teras.evento.pacodicefiscale == 1, message: this.$teras.lang.eRequired.pacodicefiscale, trigger: 'blur' }],

        panato: [{ required: this.$teras.evento.panato == 1, validator: this.checkAge, message: this.$teras.lang.eRequired.panato, trigger: 'blur,change' }],

        pacategoriaprofessionale: [{ required: this.$teras.evento.pacategoriaprofessionale == 1, type: 'number', message: this.$teras.lang.eRequired.pacategoriaprofessionale, trigger: 'blur,change' }],

        paregionelavoro: [{ required: this.$teras.evento.paregionelavoro == 1, type: 'number', message: this.$teras.lang.eRequired.paregionelavoro, trigger: 'blur,change' }],

        panazionelavoro: [{ required: this.$teras.evento.panazionelavoro == 1, message: this.$teras.lang.eRequired.panazionelavoro, trigger: 'blur,change' }],

        paassociazione: [{ required: this.$teras.evento.paassociazione != '', type: 'number', message: this.$teras.lang.eRequired.paassociazione, trigger: 'blur,change' }],

        poster: [{ required: this.$teras.evento.poster == '1', type: 'number', message: this.$teras.lang.eRequired.poster, trigger: 'blur,change' }],

        topicposter: [{ required: this.$abs.row.poster == 1 && this.$teras.topicposter.length > 0, type: 'number', message: this.$teras.lang.eRequired.topicposter, trigger: 'blur,change' }],

        comunicazione: [{ required: this.$teras.evento.comunicazione == '1', type: 'number', message: this.$teras.lang.eRequired.comunicazione, trigger: 'blur,change' }],

        topiccomunicazione: [{ required: this.$abs.row.comunicazione == 1 && this.$teras.topiccomunicazione.length > 0, type: 'number', message: this.$teras.lang.eRequired.topiccomunicazione, trigger: 'blur,change' }],

        titolo: [{ required: true, message: this.$teras.lang.eRequired.titolo, trigger: 'blur,change' }],

        parolechiave: [{ required: this.$teras.evento.parolechiave == 1, message: this.$teras.lang.eRequired.parolechiave, trigger: 'blur,change' }]

      };

      if (this.$teras.evento.id == 136) {
        rulesNow.dmdaltro = [{ required: this.$abs.row.poster == 1, type: 'number', message: 'Partecipi al Premio della Fondazione è obbligatorio', trigger: 'blur,change' }];
      }

      if (this.$teras.evento.id == 177) {
        rulesNow.dmdaltro = [{ required: true, type: 'number', message: 'Scegliere se partecipare ai Premi è obbligatorio', trigger: 'blur,change' }];
      }

      return rulesNow;
    },

    form: function form() {
      return this.$abs.row;
    }
  },
  methods: {
    onNew: function onNew() {
      var _this = this;

      this.axios.sessionGet('session_id').then(function (response) {
        console.log("CARICATO NUOVO");
        console.log(response);
        console.log(_this.$abs);
      });
      console.log("DOPO NUOVO");
    },
    onEnd: function onEnd() {
      console.log(this.$teras.autori[0].cognome);
    },
    onChange: function onChange() {
      this.$teras.preview = false;
      this.preview = false;
    },
    onEdit: function onEdit(autore) {
      this.autore.id = autore.id;
      this.autore.cognome = autore.cognome;
      this.autore.nome = autore.nome;
      this.autore.affiliazione = autore.affiliazione;
    },
    delAutore: function delAutore() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var autore = _step.value;

          if (autore.id == this.autore.id) {
            console.log(this.$teras.autori.indexOf(autore));
            this.$teras.autori.splice(this.$teras.autori.indexOf(autore), 1);
            this.autore.id = -1;
            this.autore.cognome = '';
            this.autore.nome = '';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addAutore: function addAutore() {
      if (this.autore.id < 0) {
        this.autore.id = this.$teras.autori.length;
        this.$teras.autori.push({ id: this.autore.id, cognome: this.autore.cognome, nome: this.autore.nome, affiliazione: this.autore.affiliazione });
      } else {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var autore = _step2.value;

            if (autore.id == this.autore.id) {
              autore.cognome = this.autore.cognome;
              autore.nome = this.autore.nome;
              autore.affiliazione = this.autore.affiliazione;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      console.log(this.autore);
      console.log(this.$teras.autori.length);
      this.autore.id = -1;
      this.autore.cognome = '';
      this.autore.nome = '';
    },
    destinatariChange: function destinatariChange() {
      console.log(this.destinatari);
    },
    onPreview: function onPreview(event) {
      var _this2 = this;

      if (this.$abs.row.comunicazione == 0 && this.$abs.row.poster == 0) {
        this.$notify.error({ title: 'Errore', message: 'Bisogna inviare l\'abstract come poster o comunicazione!' });
      } else {
        this.$refs.isAbs.validate(function (valid) {
          if (valid) {
            _this2.Preview();
          } else {
            _this2.$notify.error({ title: 'Errore', message: 'Non tutti i dati sono stati inseriti correttamente!' });
          }
        });
      }
    },
    Bozza: function Bozza() {
      var parent = this;
      var tosave = {
        action: 'bozze',
        browsername: this.$teras.browsername,
        browserversion: this.$teras.browserversion,
        browsertime: this.$teras.minutes,
        evento: this.$teras.evento,
        abstract: this.$abs.row,
        affiliazioni: this.$teras.affiliazioni,
        autori: this.$teras.autori
      };
      this.axios.post('api/abs/bozze/', tosave);
    },
    Preview: function Preview() {
      var _this3 = this;

      var parent = this;
      this.$abs.preview().then(function () {
        console.log("PREVIEW FATTA E FINITA");
        console.log(_this3.$abs.urlPreview);
        _this3.$teras.preview = true;
      });
    },
    saveNoEmail: function saveNoEmail() {
      var _this4 = this;

      this.$abs.sendnoemail().then(function () {
        console.log("SEND FATTO E FINITO");
        _this4.$router.push('/inviato');
      });
    },
    Save: function Save() {
      var _this5 = this;

      this.$teras.appReady = false;
      this.$abs.send().then(function () {
        console.log("SEND FATTO E FINITO");
        _this5.$abs.nuovo().then(function () {
          _this5.$router.push('/inviato');
          _this5.$teras.appReady = true;
        });
      });
    }
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-primoautore',
  components: {},
  created: function created() {
    console.log("Arrivo al abs-primoautore.vue");
    if (this.$teras.evento.poster == 2) this.$abs.row.poster = '1';
    console.log(this.$abs.row);
    if (this.$teras.evento.comunicazione == 2) this.$abs.row.comunicazione = 1;
  },
  data: function data() {
    return {
      options: {},
      autore: {
        id: -1,
        cognome: '',
        nome: '',
        affiliazione: ''
      }
    };
  },

  computed: {
    annonascita: function annonascita() {
      var year = new Date().getFullYear();
      var arr = [];
      for (var i = year - 82; i <= year - 18; i++) {
        arr.push(i);
      }return arr;
    }

  },
  methods: {
    affiliazione: function affiliazione(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.affiliazioni), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var affiliazione = _step.value;

          if (affiliazione.id == id) {
            return this.$teras.affiliazioni.indexOf(affiliazione) + 1;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return $teras.lang.errore;
    },
    onEnd: function onEnd() {},
    onEdit: function onEdit(autore) {
      this.autore.id = autore.id;
      this.autore.cognome = autore.cognome;
      this.autore.nome = autore.nome;
      this.autore.affiliazione = autore.affiliazione;
    },
    delNow: function delNow() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var autore = _step2.value;

          if (autore.id == this.autore.id) {
            console.log(this.$teras.autori.indexOf(autore));
            this.$teras.autori.splice(this.$teras.autori.indexOf(autore), 1);
            this.reset();
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    addNow: function addNow() {
      this.autore.id = this.$teras.autori.length;
      this.$teras.autori.push({ id: this.autore.id, cognome: this.autore.cognome, nome: this.autore.nome, affiliazione: this.autore.affiliazione });
      this.reset();
    },
    editNow: function editNow() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var autore = _step3.value;

          if (autore.id == this.autore.id) {
            autore.cognome = this.autore.cognome;
            autore.nome = this.autore.nome;
            autore.affiliazione = this.autore.affiliazione;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.reset();
    },
    reset: function reset() {
      this.autore.id = -1;
      this.autore.cognome = '';
      this.autore.nome = '';
      this.autore.affiliazione = '';
    }
  }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-primoautore',
  components: {},
  created: function created() {
    console.log("Arrivo al abs-primoautore.vue");
  },
  data: function data() {
    return {
      options: {},
      autore: {
        id: -1,
        cognome: '',
        nome: '',
        affiliazione: ''
      }
    };
  },

  computed: {
    annonascita: function annonascita() {
      var year = new Date().getFullYear();
      var arr = [];
      for (var i = year - 82; i <= year - 18; i++) {
        arr.push(i);
      }return arr;
    }

  },
  methods: {
    affiliazione: function affiliazione(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.affiliazioni), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var affiliazione = _step.value;

          if (affiliazione.id == id) {
            return this.$teras.affiliazioni.indexOf(affiliazione) + 1;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return $teras.lang.errore;
    },
    onEnd: function onEnd() {},
    onEdit: function onEdit(autore) {
      this.autore.id = autore.id;
      this.autore.cognome = autore.cognome;
      this.autore.nome = autore.nome;
      this.autore.affiliazione = autore.affiliazione;
    },
    delNow: function delNow() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var autore = _step2.value;

          if (autore.id == this.autore.id) {
            console.log(this.$teras.autori.indexOf(autore));
            this.$teras.autori.splice(this.$teras.autori.indexOf(autore), 1);
            this.reset();
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    addNow: function addNow() {
      this.autore.id = this.$teras.autori.length;
      this.$teras.autori.push({ id: this.autore.id, cognome: this.autore.cognome, nome: this.autore.nome, affiliazione: this.autore.affiliazione });
      this.reset();
    },
    editNow: function editNow() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var autore = _step3.value;

          if (autore.id == this.autore.id) {
            autore.cognome = this.autore.cognome;
            autore.nome = this.autore.nome;
            autore.affiliazione = this.autore.affiliazione;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.reset();
    },
    reset: function reset() {
      this.autore.id = -1;
      this.autore.cognome = '';
      this.autore.nome = '';
      this.autore.affiliazione = '';
    }
  }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-primoautore',
  components: {},
  created: function created() {
    console.log("Arrivo al abs-primoautore.vue");
  },

  computed: {
    annonascita: function annonascita() {
      var year = new Date().getFullYear();
      var arr = [];
      for (var i = year - 82; i <= year - 18; i++) {
        arr.push(parseInt(i));
      }return arr;
    }

  },
  methods: {
    affiliazione: function affiliazione(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.affiliazioni), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var affiliazione = _step.value;

          if (affiliazione.id == id) {
            return this.$teras.affiliazioni.indexOf(affiliazione) + 1;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return $teras.lang.errore;
    },
    onEnd: function onEnd() {},
    onEdit: function onEdit(autore) {
      this.autore.id = autore.id;
      this.autore.cognome = autore.cognome;
      this.autore.nome = autore.nome;
      this.autore.affiliazione = autore.affiliazione;
    },
    delNow: function delNow() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var autore = _step2.value;

          if (autore.id == this.autore.id) {
            console.log(this.$teras.autori.indexOf(autore));
            this.$teras.autori.splice(this.$teras.autori.indexOf(autore), 1);
            this.reset();
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    addNow: function addNow() {
      this.autore.id = this.$teras.autori.length;
      this.$teras.autori.push({ id: this.autore.id, cognome: this.autore.cognome, nome: this.autore.nome, affiliazione: this.autore.affiliazione });
      this.reset();
    },
    editNow: function editNow() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$teras.autori), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var autore = _step3.value;

          if (autore.id == this.autore.id) {
            autore.cognome = this.autore.cognome;
            autore.nome = this.autore.nome;
            autore.affiliazione = this.autore.affiliazione;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.reset();
    },
    reset: function reset() {
      this.autore.id = -1;
      this.autore.cognome = '';
      this.autore.nome = '';
      this.autore.affiliazione = '';
    }
  }
});

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Upload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Page_tinymce_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Page_tinymce_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Page_tinymce_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'abs-primoautore',
  components: {
    tinymce: __WEBPACK_IMPORTED_MODULE_1__Page_tinymce_vue___default.a,
    upload: __WEBPACK_IMPORTED_MODULE_0__Upload_vue___default.a
  },
  created: function created() {
    console.log("Arrivo al abs-testo.vue");
  },

  methods: {
    imageSuccess: function imageSuccess() {
      this.$notify.success({ type: 'info', message: 'Image allegata correttamente', duration: 5000 });
    },
    testoChange: function testoChange(new_value, wordCount) {
      console.log(new_value);
      console.log(wordCount);
      this.$abs.row.wordcount = wordCount;
    }
  }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinymce__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('tinymce-abs', {
  twoWay: true,
  inserted: function inserted(el, binding, vnode) {
    var self = el;
    var selec = el.id;
    console.log("CI ARRIVO ");
    console.log(this);
    tinymce.init({
      selector: '#' + el.id,
      setup: function setup(editor) {
        console.log("SETUP TINYMCE________");
        console.log(el.value);

        editor.on('init', function () {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(el.value) !== undefined && el.value != '') tinymce.get(el.id).setContent(el.value);
        });

        editor.on('keyup change', function (e) {
          var new_value = tinymce.get(el.id).getContent();

          el.value = new_value;
        });
      }
    });
  },
  unbind: function unbind() {
    tinymce.remove();
  },
  update: function update(newVal, oldVal) {
    console.log(newVal);
  }

});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['height', 'language', 'initvalue'],
  created: function created() {
    console.log("TINYMCE CREATO");
    this.thisId = "tinymce-" + Math.floor(Math.random() * 10000 + 1);
  },
  mounted: function mounted() {
    this.tinymceInit();
  },
  destroyed: function destroyed() {
    tinymce.remove();
  },

  watch: {
    '$teras.language': 'terasChange'
  },
  methods: {
    terasChange: function terasChange() {
      tinymce.remove();

      console.log("DA ABS" + this.$teras.language);

      var self = this;
      tinyMCE.execCommand("mceRepaint");
      this.tinymceInit();
    },
    tinymceInit: function tinymceInit() {
      var self = this;
      console.log("MOUNTED ABS-TINYMCE " + this.height);
      console.log(self.$el.id);
      console.log(self.$teras.language);

      tinyMCE.baseURL = "https://cloud.tinymce.com/stable";
      this.tiny = tinymce.init({
        selector: '#' + self.$el.id,
        menubar: false,
        height: self.height,
        language: self.$teras.language,
        language_url: '/bams/langs/it.js',
        oninit: "setPlainText",
        entity_encoding: "raw",
        forced_root_block: false,
        valid_elements: 'sup,sub,br',

        plugins: ['paste', 'charmap', 'wordcount,fullscreen', 'contextmenu ', ''],
        contextmenu: "charmap | subscript  superscript | copy paste",

        toolbar1: 'undo redo |   subscript  superscript |  charmap | fullscreen',


        setup: function setup(editor) {
          console.log("SETUP TINYMCE");
          console.log(self.$el.id);

          editor.on('init', function () {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(self.initValue) !== undefined) tinymce.get(self.$el.id).setContent(self.initvalue);

            var theEditor = tinymce.activeEditor;
            var wordCount = theEditor.plugins.wordcount.getCount();
            var new_value = tinymce.get(self.$el.id).getContent();
            self.$emit('input', new_value);
            self.$emit('change', new_value, wordCount);
          });

          editor.on('keyup change', function (e) {

            var theEditor = tinymce.activeEditor;
            var wordCount = theEditor.plugins.wordcount.getCount();

            var new_value = tinymce.get(self.$el.id).getContent();

            self.$emit('input', new_value);
            self.$emit('change', new_value, wordCount);
          });
        }
      });
      console.log(this.tiny);
      console.log("FINITA");
    }
  }

});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inviato',
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    var parent = this;
  },
  mounted: function mounted() {},

  methods: {
    onNew: function onNew() {
      var parent = this;
      this.$abs.new().then(function (data) {
        parent.$abs.row.browsername = parent.$teras.browsername;
        parent.$abs.row.browserversion = parent.$teras.browserversion;
        parent.$abs.row.browsertime = parent.$teras.minutes;
        parent.$abs.row.evento = parent.$teras.evento;
        parent.$abs.row.lineeguida = false;
        parent.$teras.affiliazioni = [];
        parent.$teras.autori = [];
        console.log("CARICATO NUOVO");
        console.log(parent.$abs.row);
      });
      console.log("DOPO NUOVO");
      console.log(this.$abs);
      console.log("DOPO NUOVO");
    }
  }
});

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    var parent = this;
  }
});

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inside',
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    console.log("Arrivo al Inside.vue con page  " + this.$route.params.page);
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.loading = true;
      var parent = this;
      this.axios.get('page/' + this.$route.params.page + '.html', { responseType: 'document', headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        } }).then(function (response) {
        parent.title = response.request.response.body.children.item(0).innerHTML;
        parent.page = response.request.response.body.children.item(1).innerHTML;
      }).catch(function (error) {
        console.log(error);
        parent.$route.push('/inside/error/not-find');
      });
    }
  }
});

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inviato',
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    var parent = this;
  },
  mounted: function mounted() {},

  methods: {
    onNew: function onNew() {
      var _this = this;

      this.$teras.appReady = false;
      this.$abs.nuovo().then(function () {
        if (moment(_this.$teras.evento.deadline).isAfter(moment())) {
          _this.$teras.preview = false;
          _this.$teras.absInviato = false;
          _this.$router.push('/abs-new');
        } else {
          _this.$teras.chiuso = true;
          _this.$router.push('/');
        }
        _this.$teras.appReady = true;
      });
    }
  }
});

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_layout_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__css_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__css_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('tinymce-page', {
  twoWay: true,
  inserted: function inserted(el, binding, vnode) {
    var self = el;
    var selec = el.id;
    console.log("CI ARRIVO ");
    console.log(this);
    tinymce.init({
      selector: '#' + el.id,
      setup: function setup(editor) {
        console.log("SETUP TINYMCE________");
        console.log(el.value);

        editor.on('init', function () {
          if (el.value != '') tinymce.get(el.id).setContent(el.value);
        });

        editor.on('keyup change', function (e) {
          var new_value = tinymce.get(el.id).getContent();

          el.value = new_value;
        });
      }
    });
  },
  unbind: function unbind() {
    tinymce.remove();
  },
  update: function update(newVal, oldVal) {
    console.log(newVal);
  }

});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['height', 'language', 'initvalue'],
  created: function created() {
    console.log("TINYMCE CREATO");
    this.thisId = "tinymce-" + this.$teras.random();
  },
  mounted: function mounted() {
    this.tinymceInit();
  },
  destroyed: function destroyed() {
    tinymce.remove();
  },

  watch: {
    '$teras.language': 'terasChange'
  },
  methods: {
    terasChange: function terasChange() {
      tinymce.remove();

      console.log("DA ABS" + this.$teras.language);

      var self = this;
      tinyMCE.execCommand("mceRepaint");
      this.tinymceInit();
    },
    tinymceInit: function tinymceInit() {
      var self = this;
      console.log("MOUNTED ABS-TINYMCE " + this.height);
      console.log("MOUNTED TIPOEDITO " + this.$teras.evento.tipoeditor);

      console.log(self.$el.id);
      console.log(self.$teras.language);
      console.log(document.styleSheets[2]);

      tinyMCE.baseURL = "/bams/js/tinymce";
      this.tiny = tinymce.init({
        selector: '#' + self.$el.id,

        menubar: 'file edit',
        height: self.height,
        language: self.$teras.language,

        content_css: "/bams/css/layout.css",

        oninit: "setPlainText",
        entity_encoding: "raw",
        forced_root_block: false,
        underline: { inline: 'span', styles: { 'text-decoration': 'underline' }, exact: true },
        valid_elements: self.$teras.evento.tipoeditor == 1 ? 'sup,sub,br,strong,em,span[style]' : 'br',

        relative_urls: false,
        plugins: ['paste', 'charmap', 'wordcount,fullscreen', 'contextmenu ', ''],


        contextmenu: self.$teras.evento.tipoeditor == 1 ? "charmap | subscript  superscript | copy paste" : "charmap | copy paste",
        toolbar1: self.$teras.evento.tipoeditor == 1 ? 'undo redo |   subscript  superscript |  bold italic underline | charmap | fullscreen' : 'undo redo | charmap | fullscreen',

        setup: function setup(editor) {
          console.log("SETUP TINYMCE");
          console.log(self.$el.id);

          editor.on('init', function () {
            tinymce.get(self.$el.id).setContent(self.initvalue);

            var theEditor = tinymce.activeEditor;
            var wordCount = theEditor.plugins.wordcount.getCount();
            var new_value = tinymce.get(self.$el.id).getContent();
            self.$emit('input', new_value);
            self.$emit('change', new_value, wordCount);
          });

          editor.on('keyup change', function (e) {

            var theEditor = tinymce.activeEditor;
            var wordCount = theEditor.plugins.wordcount.getCount();

            var new_value = tinymce.get(self.$el.id).getContent();

            self.$emit('input', new_value);
            self.$emit('change', new_value, wordCount);
          });
        }
      });
      console.log(this.tiny);
      console.log("FINITA");
    }
  }

});

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var pdfjsLib = __webpack_require__(283);
pdfjsLib.PDFJS.workerSrc = 'https://apps.terasmm.it/pdf.worker.js';
var vw = window.innerWidth || document.documentElement.clientWidth;
var vh = window.innerHeight || document.documentElement.clientHeight;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pdf',
  props: ['pdfPath'],
  data: function data() {
    return {
      isButton: false,
      loading: true,
      doc: {},
      currPageNumber: 1,
      viewportSet: 0,
      viewport: null,

      currentScale: null,
      currentDeltaX: null,
      currentDeltaY: null,
      adjustScale: 1,
      adjustDeltaX: 0,
      adjustDeltaY: 0,
      currentStyle: 'width:100%;position:abolute; transform-origin: left top;transform:scale(1) '
    };
  },
  created: function created() {
    console.log("PDF CON " + this.pdfPath);
    this.loadPdf(this.pdfPath);
  },

  watch: {
    pdfPath: function pdfPath(_pdfPath) {
      console.log("LOADING IS CHENGIN");
      if (_pdfPath != '') this.loadPdf(_pdfPath);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    toggle: function toggle() {
      console.log("TOGGLE " + this.isButton);
      this.isButton = !this.isButton;
    },
    loadPdf: function loadPdf(pdfPath) {
      this.loading = true;
      console.log(pdfPath);
      this.fetchData(pdfPath + '?random=' + Math.floor(Math.random() * 100000000 + 1));
    },
    fetchData: function fetchData(docPdf) {
      this.currPageNumber = 1;
      var parent = this;
      pdfjsLib.getDocument(docPdf).promise.then(function (pdfDocument) {
        console.log("FUNZIONA!");
        parent.doc = pdfDocument;
        return parent.openPage(parent.doc, 1, parent.zoom);
      }).catch(function (reason) {
        console.error('Error: ' + reason);
        parent.$notify.error({ title: 'Errore PDFjs', message: reason });
      });
    },
    openPage: function openPage(pdfFile, pageNumber, zoom) {
      var parent = this;
      pdfFile.getPage(1).then(function (page) {
        var scale = 1;
        var viewport = page.getViewport(scale);

        var vw = viewport.width;
        var vh = viewport.height;
        console.log(vw + " v " + vh);
        var Hvw = parent.$el.clientWidth - 24;

        var Hvh = parent.$el.clientHeight - 4;
        console.log(parent.$el);
        console.log(Hvw + " h " + Hvh);
        var minScale = Hvw / vw;
        console.log((vh / Hvh > vw / Hvw) + ' minscale ' + minScale);

        viewport = page.getViewport(minScale);

        var canvas = document.getElementById('theCanvas');
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        page.render(renderContext);
      });
    },
    _openPage: function _openPage(pdfFile, pageNumber, zoom) {
      var parent = this;
      pdfFile.getPage(this.currPageNumber).then(function (page) {
        console.log(vw + ' x ' + vh);
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(parent.viewport));
        if (parent.viewportSet == 0) {
          var viewport = page.getViewport(1);
          parent.viewport = page.getViewport(1800 / viewport.width);

          var vw = parent.$el.clientWidth;
          var vh = parent.$el.clientHeight;
          var Hvw = parent.$el.clientWidth;
          var Hvh = parent.$el.clientHeight;
          var minScale = vh / Hvh > vw / Hvw ? Hvw / vw : Hvh / vh;
          console.log(vw + ' minscale ' + minScale);


          console.log(parent.viewport);
        }
        console.log("_____________---");
        var canvas = document.getElementById('theCanvas');
        console.log(canvas);
        var ctx = canvas.getContext('2d');
        console.log("_____________---");

        canvas.height = parent.$el.clientHeight * 2;
        canvas.width = parent.$el.clientWidth * 2;
        var renderContext = {
          canvasContext: ctx,
          viewport: parent.viewport
        };

        page.render(renderContext);
        parent.loading = false;
      });
    },
    handleResize: function handleResize() {
      this.$teras.innerHeight = window.innerHeight;
      this.$teras.innerWidth = window.innerWidth;

      this.openPage(this.doc, 1, 1);

      console.log(this.$teras.width + ' - ' + this.$teras.innerWidth);
      console.log(window.innerWidth);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currPageNumber = val;
      this.openPage(this.doc, this.currPageNumber, this.zoom);
      console.log('current page: ' + val);
    },
    pagePrev: function pagePrev() {
      var pageNumber = Math.max(1, this.currPageNumber - 1);
      if (pageNumber !== this.currPageNumber) {
        this.currPageNumber = pageNumber;
        this.openPage(this.doc, this.currPageNumber);
      }
    },
    pageNext: function pageNext() {
      var pageNumber = Math.min(this.doc.numPages, this.currPageNumber + 1);
      if (pageNumber !== this.currPageNumber) {
        this.currPageNumber = pageNumber;
        this.openPage(this.doc, this.currPageNumber);
      }
    }
  }
});

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var pdfjsLib = __webpack_require__(283);
pdfjsLib.PDFJS.workerSrc = 'https://apps.terasmm.it/pdf.worker.js';
var vw = window.innerWidth || document.documentElement.clientWidth;
var vh = window.innerHeight || document.documentElement.clientHeight;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pdf',
  props: ['pdfPath'],
  data: function data() {
    return {
      isButton: false,
      loading: true,
      doc: {},
      currPageNumber: 1,
      viewportSet: 0,
      viewport: null,

      currentScale: null,
      currentDeltaX: null,
      currentDeltaY: null,
      adjustScale: 1,
      adjustDeltaX: 0,
      adjustDeltaY: 0,
      currentStyle: 'width:100%;position:abolute; transform-origin: left top;transform:scale(1) '
    };
  },
  created: function created() {
    console.log("PDF CON " + this.pdfPath);
    this.loadPdf(this.pdfPath);
  },

  watch: {
    pdfPath: function pdfPath(_pdfPath) {
      console.log("LOADING IS CHENGIN");
      if (_pdfPath != '') this.loadPdf(_pdfPath + '?random=' + Math.floor(Math.random() * 100000000 + 1));
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    toggle: function toggle() {
      console.log("TOGGLE " + this.isButton);
      this.isButton = !this.isButton;
    },
    loadPdf: function loadPdf(pdfPath) {
      this.loading = true;

      var parent = this;
      this.axios.get(pdfPath, { responseType: 'blob' }).then(function (response) {
        console.log("DATA SIZE: " + response.data.size);
        if (response.data.size > 0) {
          parent.fetchData(window.URL.createObjectURL(response.data));
        }
      }).catch(function (error) {
        parent.$notify.error({ title: 'Errore', message: error.response });
      });
    },
    fetchData: function fetchData(docPdf) {
      this.currPageNumber = 1;
      var parent = this;
      pdfjsLib.getDocument(docPdf).promise.then(function (pdfDocument) {
        console.log("FUNZIONA!");
        parent.doc = pdfDocument;
        return parent.openPage(parent.doc, 1, parent.zoom);
      }).catch(function (reason) {
        console.error('Error: ' + reason);
        parent.$notify.error({ title: 'Errore PDFjs', message: reason });
      });
    },
    openPage: function openPage(pdfFile, pageNumber, zoom) {
      var parent = this;
      pdfFile.getPage(1).then(function (page) {
        var scale = 1;
        var viewport = page.getViewport(scale);

        var vw = viewport.width;
        var vh = viewport.height;
        console.log(vw + " v " + vh);
        var Hvw = parent.$el.clientWidth - 24;

        var Hvh = parent.$el.clientHeight - 4;
        console.log(parent.$el);
        console.log(Hvw + " h " + Hvh);
        var minScale = Hvw / vw;
        console.log((vh / Hvh > vw / Hvw) + ' minscale ' + minScale);

        viewport = page.getViewport(minScale);

        var canvas = document.getElementById('theCanvas');
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        page.render(renderContext);
      });
    },
    _openPage: function _openPage(pdfFile, pageNumber, zoom) {
      var parent = this;
      pdfFile.getPage(this.currPageNumber).then(function (page) {
        console.log(vw + ' x ' + vh);
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(parent.viewport));
        if (parent.viewportSet == 0) {
          var viewport = page.getViewport(1);
          parent.viewport = page.getViewport(1800 / viewport.width);

          var vw = parent.$el.clientWidth;
          var vh = parent.$el.clientHeight;
          var Hvw = parent.$el.clientWidth;
          var Hvh = parent.$el.clientHeight;
          var minScale = vh / Hvh > vw / Hvw ? Hvw / vw : Hvh / vh;
          console.log(vw + ' minscale ' + minScale);


          console.log(parent.viewport);
        }
        console.log("_____________---");
        var canvas = document.getElementById('theCanvas');
        console.log(canvas);
        var ctx = canvas.getContext('2d');
        console.log("_____________---");

        canvas.height = parent.$el.clientHeight * 2;
        canvas.width = parent.$el.clientWidth * 2;
        var renderContext = {
          canvasContext: ctx,
          viewport: parent.viewport
        };

        page.render(renderContext);
        parent.loading = false;
      });
    },
    handleResize: function handleResize() {
      this.$teras.innerHeight = window.innerHeight;
      this.$teras.innerWidth = window.innerWidth;

      this.openPage(this.doc, 1, 1);

      console.log(this.$teras.width + ' - ' + this.$teras.innerWidth);
      console.log(window.innerWidth);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currPageNumber = val;
      this.openPage(this.doc, this.currPageNumber, this.zoom);
      console.log('current page: ' + val);
    },
    pagePrev: function pagePrev() {
      var pageNumber = Math.max(1, this.currPageNumber - 1);
      if (pageNumber !== this.currPageNumber) {
        this.currPageNumber = pageNumber;
        this.openPage(this.doc, this.currPageNumber);
      }
    },
    pageNext: function pageNext() {
      var pageNumber = Math.min(this.doc.numPages, this.currPageNumber + 1);
      if (pageNumber !== this.currPageNumber) {
        this.currPageNumber = pageNumber;
        this.openPage(this.doc, this.currPageNumber);
      }
    }
  }
});

/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var moment = __webpack_require__(0);
moment.locale('it');
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-footer',
  filters: {
    data: function data(value, formato) {
      return moment(value).format(formato);
    }
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-header',
  watch: {
    '$teras.language': 'terasChange'
  },
  methods: {
    terasChange: function terasChange() {
      console.log(this.$teras.language);
    },
    changeLang: function changeLang(lang) {
      this.$teras.language = lang;
      this.$teras.lang = this.$teras[this.$teras.language];
    }
  }
});

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-navbar',
  created: function created() {
    console.log("Created Site-logged.vue");
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      if (keyPath == '/sezione/2/') {} else if (keyPath == '/page/f/4') {} else {}

      console.log();
    }
  }
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('tinymce-teras', {
  twoWay: true,
  inserted: function inserted(el, binding, vnode) {
    var self = el;
    var selec = el.id;
    console.log("CI ARRIVO ");
    console.log(this);
    tinymce.init({
      selector: '#' + el.id,
      setup: function setup(editor) {
        console.log("SETUP TINYMCE______________-");
        console.log(el.value);

        editor.on('init', function () {
          if (el.value != '') tinymce.get(el.id).setContent(el.value);
        });

        editor.on('keyup change', function (e) {
          var new_value = tinymce.get(el.id).getContent();

          el.value = new_value;
        });
      }
    });
  },
  unbind: function unbind() {
    tinymce.remove();
  },
  update: function update(newVal, oldVal) {
    console.log(newVal);
  }

});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['height'],
  created: function created() {
    console.log("TINYMCE CREATO");
    this.thisId = "tinymce-" + Math.floor(Math.random() * 10000 + 1);
  },
  mounted: function mounted() {
    var self = this;
    console.log("MOUNTED TINYMCE " + this.height);
    console.log(self.$el.id);
    tinyMCE.baseURL = "https://cdn.tinymce.com/4";
    this.tiny = tinymce.init({
      selector: '#' + self.$el.id,
      menubar: false,
      height: self.height,


      plugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'emoticons template paste textcolor colorpicker textpattern imagetools codesample toc'],
      toolbar1: 'undo redo |  styleselect | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',


      setup: function setup(editor) {
        console.log("SETUP TINYMCE");
        console.log(self.$el.id);

        editor.on('init', function () {});

        editor.on('keyup change', function (e) {
          var new_value = tinymce.get(self.$el.id).getContent();
          self.$el.value = new_value;
          self.$emit('input', new_value);
          self.$emit('change', new_value);
        });
      }
    });
    console.log(this.tiny);
    console.log("FINITA");
  },
  destroyed: function destroyed() {
    tinymce.remove();
  }
});

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);




/* harmony default export */ __webpack_exports__["default"] = ({
   props: ['action', 'savedir', 'previewurl', 'value', 'extensions'],
   components: {},
   created: function created() {},
   data: function data() {
      return {
         loading: {},
         docfile: this.value
      };
   },

   watch: {
      docfile: function docfile(val) {
         this.$emit('change', this.docfile);
      }
   },
   computed: {
      file: function file() {
         if (typeof this.docfile != 'undefined' && this.docfile != '' && this.docfile != '[]') {
            return JSON.parse(this.docfile)[0];
         } else {
            return { name: 'no-file', url: '' };
         }
      },
      fileList: function fileList() {
         if (this.docfile != '') {
            return JSON.parse(this.docfile);
         } else {
            return [];
         }
      }
   },
   methods: {
      uploadNow: function uploadNow() {
         console.log(arguments);
      },
      onError: function onError(e, files, fileList) {
         console.log("UPLOAD ERROR");
         this.loading.close();
         this.$alert('Error during uploading file, please try again', 'UPLOAD ERROR', { type: 'error' });
      },
      onExceed: function onExceed(files, fileList) {
         console.log("UPLOAD EXCEED");
         this.loading.close();
         this.$alert(e, 'UPLOAD EXCEED', { type: 'error' });
      },
      beforeUpload: function beforeUpload(file) {
         this.loading = this.$loading({
            lock: true,
            text: 'Upload in progress....',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
         });
         console.log(file);
         return true;
      },
      onSuccess: function onSuccess(response, file, fileList) {
         console.log("UPLOAD SUCCESS");
         console.log(response);
         this.loading.close();

         var filesFilter = [];
         var files2save = [];
         var _iteratorNormalCompletion = true;
         var _didIteratorError = false;
         var _iteratorError = undefined;

         try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(fileList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
               var fileIn = _step.value;

               if (fileIn.name == response.data.original) {
                  fileIn.url = response.data.filename;
                  filesFilter.push(fileIn);
                  files2save.push({ name: fileIn.name, url: fileIn.url });
                  break;
               }
            }
         } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
         } finally {
            try {
               if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
               }
            } finally {
               if (_didIteratorError) {
                  throw _iteratorError;
               }
            }
         }

         fileList = filesFilter;

         var nameExt = files2save[0].name.split('.').pop();


         if (this.extensions == '' || this.extensions.split(',').indexOf(nameExt.toLowerCase()) > -1) {
            this.docfile = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(files2save);
            this.$emit('success', this.docfile);
         } else {
            this.$alert('FILE EXTENSION NOT VALID', { type: 'error' });
         }
      }
   }
});

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    var parent = this;
  }
});

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'inside',
  data: function data() {
    return {
      title: '',
      page: ''
    };
  },
  created: function created() {
    console.log("Arrivo al Inside.vue con page  " + this.$route.params.page);
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.loading = true;
      var parent = this;
      this.axios.get('page/' + this.$route.params.page + '.html', { responseType: 'document', headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        } }).then(function (response) {
        parent.title = response.request.response.body.children.item(0).innerHTML;
        parent.page = response.request.response.body.children.item(1).innerHTML;
      }).catch(function (error) {
        console.log(error);
        parent.$route.push('/inside/error/not-find');
      });
    }
  }
});

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinymce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinymce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('tinymce-teras', {
  twoWay: true,
  inserted: function inserted(el, binding, vnode) {
    var self = el;
    var selec = el.id;
    console.log("CI ARRIVO ");
    console.log(this);
    tinymce.init({
      selector: '#' + el.id,
      setup: function setup(editor) {
        console.log("SETUP TINYMCE______________-");
        console.log(el.value);

        editor.on('init', function () {
          if (el.value != '') tinymce.get(el.id).setContent(el.value);
        });

        editor.on('keyup change', function (e) {
          var new_value = tinymce.get(el.id).getContent();

          el.value = new_value;
        });
      }
    });
  },
  unbind: function unbind() {
    tinymce.remove();
  },
  update: function update(newVal, oldVal) {
    console.log(newVal);
  }

});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['height'],
  created: function created() {
    console.log("TINYMCE CREATO");
    this.thisId = "tinymce-" + Math.floor(Math.random() * 10000 + 1);
  },
  mounted: function mounted() {
    var self = this;
    console.log("MOUNTED TINYMCE " + this.height);
    console.log(self.$el.id);
    tinyMCE.baseURL = "https://cdn.tinymce.com/4";
    this.tiny = tinymce.init({
      selector: '#' + self.$el.id,
      menubar: false,
      height: self.height,


      plugins: ['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality', 'emoticons template paste textcolor colorpicker textpattern imagetools codesample toc'],
      toolbar1: 'undo redo |  styleselect | bold italic | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',


      setup: function setup(editor) {
        console.log("SETUP TINYMCE");
        console.log(self.$el.id);

        editor.on('init', function () {});

        editor.on('keyup change', function (e) {
          var new_value = tinymce.get(self.$el.id).getContent();
          self.$el.value = new_value;
          self.$emit('input', new_value);
          self.$emit('change', new_value);
        });
      }
    });
    console.log(this.tiny);
    console.log("FINITA");
  },
  destroyed: function destroyed() {
    tinymce.remove();
  }
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dbitem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aes__ = __webpack_require__(103);



var EventEmitter = __webpack_require__(39).EventEmitter;
var eventEmitter = new EventEmitter();




var dbitem = function () {
    function dbitem(args) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, dbitem);

        this.event = eventEmitter;
        this.axios = __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */];
        this.aes = __WEBPACK_IMPORTED_MODULE_4__aes__["a" /* default */];
        this.mysql = {
            db: __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].mysql.db,
            table: 'tabellanonesistente',
            primary: 'id'
        };
        this.row = {};
        return this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(dbitem, [{
        key: 'objmerge',
        value: function objmerge() {
            var objReturn = {};
            if (arguments.length > 0) for (var prop in arguments[0]) {
                objReturn[prop] = arguments[0][prop];
            }if (arguments.length > 1) for (var prop in arguments[1]) {
                objReturn[prop] = arguments[1][prop];
            }if (arguments.length > 2) for (var prop in arguments[2]) {
                objReturn[prop] = arguments[2][prop];
            }if (arguments.length > 3) for (var prop in arguments[3]) {
                objReturn[prop] = arguments[3][prop];
            }return objReturn;
        }
    }, {
        key: 'new',
        value: function _new() {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this.load('').then(function (response) {
                    resolve(response);
                });
            });
        }
    }, {
        key: 'loadEncode',
        value: function loadEncode(encodeId) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.load(_this2.aes.decode(encodeId)).then(function (response) {
                    resolve(response);
                });
            });
        }
    }, {
        key: 'load',
        value: function load(id) {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this3.row = {};
                var mySql = _this3.objmerge(_this3.mysql, { id: id });
                _this3.axios.post(_this3.axios.apiUrl + _this3.axios.mysql.composer + '/load', mySql).then(function (response) {
                    var api = response.data;
                    _this3.row = api.data.row;
                    resolve(api.data);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this4 = this,
                _arguments = arguments;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var mySql = _this4.objmerge(_this4.mysql, { row: _this4.row });
                if (_arguments.length > 0) mySql = _this4.objmerge(mySql, _arguments[0]);
                _this4.axios.post(_this4.axios.apiUrl + _this4.axios.mysql.composer + '/save', mySql).then(function (response) {
                    var api = response.data;
                    _this4.row = api.data.row;
                    _this4.event.emit('saved', api.data);
                    console.log("FINITO SAVE");
                    resolve(api.data);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }, {
        key: 'delete',
        value: function _delete(id) {
            var _this5 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var mySql = _this5.objmerge(_this5.mysql, { id: id });
                _this5.axios.post(_this5.axios.apiUrl + _this5.axios.mysql.composer + '/delete', mySql).then(function (response) {
                    var api = response.data;
                    _this5.row = {};
                    _this5.event.emit('deleted', api.data);
                    resolve(api.data);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }]);

    return dbitem;
}();

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teras__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_it__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__axios__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_layout_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_layout_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__abs__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__en__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__it__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__it_136__ = __webpack_require__(306);

if (!__WEBPACK_IMPORTED_MODULE_0_bowser___default.a.check({ msie: "11.0" })) {
  alert('La versione del suo browser non è compatibile con il gestionale. La preghiamo di usare un browser diverso!');

  window.location.href = "https://www.biomedia.net";
}









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_it___default.a });



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */]);






__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].en = __WEBPACK_IMPORTED_MODULE_12__en__["a" /* default */];


__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].it = __WEBPACK_IMPORTED_MODULE_13__it__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].lang = __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */][__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].language];

__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].browsername = __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.name;
__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].browserversion = __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.version;

function goReady(url) {
  __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace(url);
  __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].appReady = true;
}

var moment = __webpack_require__(0);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].onReady(function () {
  console.log("ROUTE FIRST");
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionGet('session_id').then(function (data) {
    __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionID = data.key;
    console.log(sessionStorage.getItem('sessionID'));
    if (sessionStorage.getItem('sessionID') != '') sessionStorage.setItem('sessionID', data.key);
    console.log("ROUTE FIRST AFTER SESSION STARTED CON ID " + __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionID);

    console.log(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute);
    console.log(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name);

    switch (__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name) {
      case 'home':
      case 'absNew':
        console.log("HOME: VERIFICO CHE ESISTE LA SESSION PER EVENTO e ABS");
        __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionGet('evento').then(function (data) {
          if ('key' in data) {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento = data.key;
            console.log("EVENTO READY " + __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.id);
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.emit('eventoReady');
            if (moment(__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.deadline).isAfter(moment())) {
              __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchOne', 'SELECT abstract FROM token LEFT JOIN abstract ON abstract.id=token.abstract WHERE abstract.id IS NOT NULL AND token.id= →token', { token: __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionID }).then(function (data) {
                console.log("+++++++++++++++++++++++++++++++++++++++++++++++TROVATO ABSTRACT N." + data.result);
                if (data.result == false) {
                  __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].nuovo().then(function () {
                    goReady('/abs-new');
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].load(data.result).then(function (data) {
                    __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].lineeguida = true;
                    __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero', { evento: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.id, abstract: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.id }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'autori');
                    __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero', { evento: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.id, abstract: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.id }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'affiliazioni').then(function (data) {
                      goReady('/abs-new');
                    });
                  });
                }
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].chiuso = true;
              goReady('/');
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].noevento = true;
            goReady('/');
          }
        });
        break;

      case 'edit':
        console.log("EDIT: CARICO I DATI DI UN ABS SALVATO");
        __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchOne', 'SELECT id FROM abstract WHERE id = ←abstract AND premail= →premail', __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.params).then(function (data) {
          if (data.result == false) {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].noabstract = true;
            goReady('/');
          } else {
            console.log("TROVATO ABSTRACT N.");
            console.log(data);
            __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].load(data.result).then(function (data) {
              __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('doQuery', "REPLACE INTO token VALUES (→id,←abstract)", { id: __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionID, abstract: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.id });
              __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].lineeguida = true;
              __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT * FROM autore WHERE evento = →evento AND abstract = →abstract ORDER BY numero', { evento: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.evento, abstract: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.id }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'autori');
              __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT numero AS id, nome AS nome FROM affiliazione WHERE evento = →evento AND abstract = →abstract ORDER BY numero', { evento: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.evento, abstract: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.id }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'affiliazioni').then(function (data) {
                goReady('/abs-new');
              });

              __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchRow', 'SELECT * FROM evento WHERE id= →evento', { evento: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].row.evento }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'evento').then(function (data) {
                __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionSet('evento', data.result);
                __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.emit('eventoReady');
              });
            });
          }
        });
        break;

      case 'startnodeadline':
      case 'start':
        console.log("START: CARICO I DATI DI UN EVENTO e INVIO UN ABS NUOVO");
        __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchRow', 'SELECT * FROM evento WHERE id= →evento', __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.params, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'evento').then(function (data) {
          __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionSet('evento', data.result);

          if (__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.lingua == 2) {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].language = 'en';
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].lang = __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */][__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].language];
          }
          if (__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.id == 136) {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].it = __WEBPACK_IMPORTED_MODULE_14__it_136__["a" /* default */];
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].language = 'it';
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].lang = __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */][__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].language];
          }
          if (__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.name == 'startnodeadline' || moment(__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.deadline).isAfter(moment())) {
            __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].nuovo().then(function () {
              goReady('/abs-new');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].chiuso = true;
            goReady('/');
          }
          __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.emit('eventoReady');
        });
        break;

      case 'startconsulta':
        console.log("START CONSULTA: CARICO I DATI DI UN EVENTO e INVIO ALL'INSERIMENTO DEL CODICE");
        __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchRow', 'SELECT * FROM evento WHERE id= →evento', __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.params, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'evento').then(function (data) {
          __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionSet('evento', data.result);
          goReady('/consulta');
          __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.emit('eventoReady');
        });
        break;

      case 'consulta':
        console.log("CONSULTA: CARICO I DATI DI UN EVENTO e INVIO ALL'INSERIMENTO DEL CODICE");
        __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionGet('evento').then(function (data) {
          if ('key' in data) {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento = data.key;
            goReady('/consulta');
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.emit('eventoReady');
          } else {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].noevento = true;
            goReady('/');
          }
        });
        break;

      default:
        console.log("HOME: VERIFICO CHE ESISTE LA SESSION PER EVENTO e ABS");
        __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].sessionGet('evento').then(function (data) {
          if ('key' in data) {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento = data.key;
            console.log("EVENTO READY");
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.emit('eventoReady');
            if (moment(__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.deadline).isAfter(moment())) {
              __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */].nuovo().then(function () {
                goReady('/abs-new');
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].chiuso = true;
              goReady('/');
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].noevento = true;
            goReady('/');
          }
        });
    }
  });
});

__WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].event.on('eventoReady', function () {
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchRow', 'SELECT * FROM bm_bvent.evento WHERE id= →bvent', { bvent: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.bvent }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'bvent');
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', "SELECT id,CONCAT(sigla,' ',nome) AS nome_it,CONCAT(sigla,' ',nome) AS nome_en FROM bm_bvent.associazione WHERE FIND_IN_SET(id, →associazioni) ORDER BY sigla,nome", { associazioni: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.paassociazione }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'associazioni');
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT * FROM topic WHERE evento= →evento AND FIND_IN_SET(1,tipo) ORDER BY peso,nome', { evento: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.id }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'topicposter');
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT * FROM topic WHERE evento= →evento AND FIND_IN_SET(2,tipo) ORDER BY peso,nome', { evento: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */].evento.id }, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'topiccomunicazione');
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT id, nome AS nome_it, nomeeng AS nome_en FROM bm_bvent.categoria ORDER BY nome', {}, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'categoriaprofessionale');
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT 99 as id,\'ESTERO\' as nome_it,\'ESTERO\' AS nome_en UNION ALL (SELECT id, nome AS nome_it, nome AS nome_en FROM options.regione ORDER BY nome ) ', {}, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'regione');
  __WEBPACK_IMPORTED_MODULE_8__axios__["a" /* default */].query('fetchAll', 'SELECT iso3 AS id, nome AS nome_it, nomeeng AS nome_en FROM codicefiscale.nazione ORDER BY peso,nome', {}, __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */], 'nazione');
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$teras = __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$abs = __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */];
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],

  data: {
    teras: __WEBPACK_IMPORTED_MODULE_4__teras__["a" /* default */],
    abs: __WEBPACK_IMPORTED_MODULE_11__abs__["a" /* default */]
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 527:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 141,
	"./af.js": 141,
	"./ar": 149,
	"./ar-dz": 142,
	"./ar-dz.js": 142,
	"./ar-kw": 143,
	"./ar-kw.js": 143,
	"./ar-ly": 144,
	"./ar-ly.js": 144,
	"./ar-ma": 145,
	"./ar-ma.js": 145,
	"./ar-ps": 146,
	"./ar-ps.js": 146,
	"./ar-sa": 147,
	"./ar-sa.js": 147,
	"./ar-tn": 148,
	"./ar-tn.js": 148,
	"./ar.js": 149,
	"./az": 150,
	"./az.js": 150,
	"./be": 151,
	"./be.js": 151,
	"./bg": 152,
	"./bg.js": 152,
	"./bm": 153,
	"./bm.js": 153,
	"./bn": 155,
	"./bn-bd": 154,
	"./bn-bd.js": 154,
	"./bn.js": 155,
	"./bo": 156,
	"./bo.js": 156,
	"./br": 157,
	"./br.js": 157,
	"./bs": 158,
	"./bs.js": 158,
	"./ca": 159,
	"./ca.js": 159,
	"./cs": 160,
	"./cs.js": 160,
	"./cv": 161,
	"./cv.js": 161,
	"./cy": 162,
	"./cy.js": 162,
	"./da": 163,
	"./da.js": 163,
	"./de": 166,
	"./de-at": 164,
	"./de-at.js": 164,
	"./de-ch": 165,
	"./de-ch.js": 165,
	"./de.js": 166,
	"./dv": 167,
	"./dv.js": 167,
	"./el": 168,
	"./el.js": 168,
	"./en-au": 169,
	"./en-au.js": 169,
	"./en-ca": 170,
	"./en-ca.js": 170,
	"./en-gb": 171,
	"./en-gb.js": 171,
	"./en-ie": 172,
	"./en-ie.js": 172,
	"./en-il": 173,
	"./en-il.js": 173,
	"./en-in": 174,
	"./en-in.js": 174,
	"./en-nz": 175,
	"./en-nz.js": 175,
	"./en-sg": 176,
	"./en-sg.js": 176,
	"./eo": 177,
	"./eo.js": 177,
	"./es": 181,
	"./es-do": 178,
	"./es-do.js": 178,
	"./es-mx": 179,
	"./es-mx.js": 179,
	"./es-us": 180,
	"./es-us.js": 180,
	"./es.js": 181,
	"./et": 182,
	"./et.js": 182,
	"./eu": 183,
	"./eu.js": 183,
	"./fa": 184,
	"./fa.js": 184,
	"./fi": 185,
	"./fi.js": 185,
	"./fil": 186,
	"./fil.js": 186,
	"./fo": 187,
	"./fo.js": 187,
	"./fr": 190,
	"./fr-ca": 188,
	"./fr-ca.js": 188,
	"./fr-ch": 189,
	"./fr-ch.js": 189,
	"./fr.js": 190,
	"./fy": 191,
	"./fy.js": 191,
	"./ga": 192,
	"./ga.js": 192,
	"./gd": 193,
	"./gd.js": 193,
	"./gl": 194,
	"./gl.js": 194,
	"./gom-deva": 195,
	"./gom-deva.js": 195,
	"./gom-latn": 196,
	"./gom-latn.js": 196,
	"./gu": 197,
	"./gu.js": 197,
	"./he": 198,
	"./he.js": 198,
	"./hi": 199,
	"./hi.js": 199,
	"./hr": 200,
	"./hr.js": 200,
	"./hu": 201,
	"./hu.js": 201,
	"./hy-am": 202,
	"./hy-am.js": 202,
	"./id": 203,
	"./id.js": 203,
	"./is": 204,
	"./is.js": 204,
	"./it": 206,
	"./it-ch": 205,
	"./it-ch.js": 205,
	"./it.js": 206,
	"./ja": 207,
	"./ja.js": 207,
	"./jv": 208,
	"./jv.js": 208,
	"./ka": 209,
	"./ka.js": 209,
	"./kk": 210,
	"./kk.js": 210,
	"./km": 211,
	"./km.js": 211,
	"./kn": 212,
	"./kn.js": 212,
	"./ko": 213,
	"./ko.js": 213,
	"./ku": 215,
	"./ku-kmr": 214,
	"./ku-kmr.js": 214,
	"./ku.js": 215,
	"./ky": 216,
	"./ky.js": 216,
	"./lb": 217,
	"./lb.js": 217,
	"./lo": 218,
	"./lo.js": 218,
	"./lt": 219,
	"./lt.js": 219,
	"./lv": 220,
	"./lv.js": 220,
	"./me": 221,
	"./me.js": 221,
	"./mi": 222,
	"./mi.js": 222,
	"./mk": 223,
	"./mk.js": 223,
	"./ml": 224,
	"./ml.js": 224,
	"./mn": 225,
	"./mn.js": 225,
	"./mr": 226,
	"./mr.js": 226,
	"./ms": 228,
	"./ms-my": 227,
	"./ms-my.js": 227,
	"./ms.js": 228,
	"./mt": 229,
	"./mt.js": 229,
	"./my": 230,
	"./my.js": 230,
	"./nb": 231,
	"./nb.js": 231,
	"./ne": 232,
	"./ne.js": 232,
	"./nl": 234,
	"./nl-be": 233,
	"./nl-be.js": 233,
	"./nl.js": 234,
	"./nn": 235,
	"./nn.js": 235,
	"./oc-lnc": 236,
	"./oc-lnc.js": 236,
	"./pa-in": 237,
	"./pa-in.js": 237,
	"./pl": 238,
	"./pl.js": 238,
	"./pt": 240,
	"./pt-br": 239,
	"./pt-br.js": 239,
	"./pt.js": 240,
	"./ro": 241,
	"./ro.js": 241,
	"./ru": 242,
	"./ru.js": 242,
	"./sd": 243,
	"./sd.js": 243,
	"./se": 244,
	"./se.js": 244,
	"./si": 245,
	"./si.js": 245,
	"./sk": 246,
	"./sk.js": 246,
	"./sl": 247,
	"./sl.js": 247,
	"./sq": 248,
	"./sq.js": 248,
	"./sr": 250,
	"./sr-cyrl": 249,
	"./sr-cyrl.js": 249,
	"./sr.js": 250,
	"./ss": 251,
	"./ss.js": 251,
	"./sv": 252,
	"./sv.js": 252,
	"./sw": 253,
	"./sw.js": 253,
	"./ta": 254,
	"./ta.js": 254,
	"./te": 255,
	"./te.js": 255,
	"./tet": 256,
	"./tet.js": 256,
	"./tg": 257,
	"./tg.js": 257,
	"./th": 258,
	"./th.js": 258,
	"./tk": 259,
	"./tk.js": 259,
	"./tl-ph": 260,
	"./tl-ph.js": 260,
	"./tlh": 261,
	"./tlh.js": 261,
	"./tr": 262,
	"./tr.js": 262,
	"./tzl": 263,
	"./tzl.js": 263,
	"./tzm": 265,
	"./tzm-latn": 264,
	"./tzm-latn.js": 264,
	"./tzm.js": 265,
	"./ug-cn": 266,
	"./ug-cn.js": 266,
	"./uk": 267,
	"./uk.js": 267,
	"./ur": 268,
	"./ur.js": 268,
	"./uz": 270,
	"./uz-latn": 269,
	"./uz-latn.js": 269,
	"./uz.js": 270,
	"./vi": 271,
	"./vi.js": 271,
	"./x-pseudo": 272,
	"./x-pseudo.js": 272,
	"./yo": 273,
	"./yo.js": 273,
	"./zh-cn": 274,
	"./zh-cn.js": 274,
	"./zh-hk": 275,
	"./zh-hk.js": 275,
	"./zh-mo": 276,
	"./zh-mo.js": 276,
	"./zh-tw": 277,
	"./zh-tw.js": 277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 543;

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EventEmitter = __webpack_require__(39).EventEmitter;
var eventEmitter = new EventEmitter();

/* harmony default export */ __webpack_exports__["a"] = ({
    event: eventEmitter,
    name: 'api.biomedia.net',
    version: '2604.001',
    urlsite: document.location.origin + '/bams/',
    app: document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1,
    uuid: '0123456789',
    onesignal: 'non disponibile',
    platform: document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1 ? 'app' : 'desktop',
    online: true,
    innerHeight: window.innerHeight,
    screenHeight: screen.height,
    height: window.innerHeight,
    width: screen.width,
    pixelRatio: window.devicePixelRatio,

    appReady: false,
    routeInitial: '/',

    minutes: 0,
    language: 'it',
    lang: {},
    en: {},
    it: {},

    chiuso: false,
    preview: false,
    absInviato: false,

    evento: {},
    bvent: {},
    topicposter: {},
    topiccomunicazione: {},
    categoriaprofessionale: {},
    nazionelavoro: {},
    regionelavoro: {},
    associazioni: {},

    abs: {},
    affiliazioni: [],
    autori: [],

    sostituisci: function sostituisci(cosa) {
        return this.lang[cosa];
    },

    random: function random() {
        return Math.floor(Math.random() * 10000 + 1);
    }
});

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  "data-v-ca599640",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(504)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(594),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(503)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(593),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(605),
  /* scopeId */
  "data-v-4d75f5dd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(603),
  /* scopeId */
  "data-v-266e5812",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(602),
  /* scopeId */
  "data-v-23f5854f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(596),
  /* scopeId */
  "data-v-0ab6d828",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  "data-v-d5d70d78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  "data-v-93b9ab9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  "data-v-53ecdb3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(595),
  /* scopeId */
  "data-v-0a1e2a1b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(606),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 592:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$abs.row.pa > -1) ? _c('div', {
    staticClass: "abs-testo"
  }, [(false) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Tipoeditor " + _vm._s(typeof _vm.$teras.evento.tipoeditor) + " » " + _vm._s(_vm.$teras.evento.allegato) + "   ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.titolo,
      "prop": "titolo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$teras.lang.titoloHolder
    },
    model: {
      value: (_vm.$abs.row.titolo),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "titolo", $$v)
      },
      expression: "$abs.row.titolo"
    }
  })], 1), _vm._v(" "), ((typeof _vm.$teras.evento.tipoeditor != 'undefined')) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.testo
    }
  }, [_c('tinymce', {
    attrs: {
      "initvalue": _vm.$abs.row.testo,
      "height": "300",
      "language": _vm.$teras.language
    },
    on: {
      "change": _vm.testoChange
    },
    model: {
      value: (_vm.$abs.row.testo),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "testo", $$v)
      },
      expression: "$abs.row.testo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row pad help"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datitestoHelp)
    }
  })]), _vm._v(" "), (_vm.$abs.row.wordcount > _vm.$teras.evento.maxparole) ? _c('div', {
    staticClass: "row pad help",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col s10"
  }, [_vm._v("\n        " + _vm._s(_vm.$teras.lang.maxparoleWarning) + ": " + _vm._s(_vm.$teras.evento.maxparole) + "  \n    ")])]) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.parolechiave == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.parolechiave,
      "prop": "parolechiave"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$teras.lang.parolechiaveHolder
    },
    model: {
      value: (_vm.$abs.row.parolechiave),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "parolechiave", $$v)
      },
      expression: "$abs.row.parolechiave"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.allegato == 1) ? _c('div', {
    staticClass: "row help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "for": "allegato"
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.allegato))])]), _vm._v(" "), _c('upload', {
    staticClass: "col s10",
    attrs: {
      "value": _vm.$abs.row.allegato,
      "action": "https://api.biomedia.net/201806/vue/upload/",
      "savedir": 'bvent.biomedia.net/abstracts/' + _vm.$teras.evento.id + '/',
      "previewurl": 'https://bvent.biomedia.net/abstracts/' + _vm.$teras.evento.id + '/',
      "extensions": "png,PNG,jpg,JPG,jpeg,JPEG"
    },
    on: {
      "change": function (val) { return _vm.$abs.row.allegato = val; },
      "success": _vm.imageSuccess
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("warning")])])
}]}

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    attrs: {
      "id": _vm.thisId
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((typeof _vm.$teras.evento.id != 'undefined')) ? _c('div', {
    staticClass: "nl-edit"
  }, [_c('el-form', {
    ref: "isAbs",
    attrs: {
      "model": _vm.$abs.row,
      "rules": _vm.rules,
      "label-width": "180px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.preview.apply(null, arguments)
      }
    }
  }, [(!_vm.$teras.preview) ? _c('div', [(_vm.$abs.row.step == 0) ? _c('div', [_c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.lineeguidaSection)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row row-form"
  }, [_c('div', {
    staticClass: "col s10 offset-s2",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.evento.lineeguida)
    }
  })]), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.$abs.lineeguida),
      callback: function($$v) {
        _vm.$set(_vm.$abs, "lineeguida", $$v)
      },
      expression: "$abs.lineeguida"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.lineeguidaCheck)
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datipresentatoreSection)
    }
  }), _vm._v(" "), (_vm.$abs.lineeguida > 0) ? _c('div', [_c('div', {
    staticClass: "row pad help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datipresentatoreHelp)
    }
  })]), _vm._v(" "), _c('absPresentatore')], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.affiliazioniSection)
    }
  }), _vm._v(" "), (_vm.$abs.row.prnome != '' && _vm.$abs.row.prcognome != '' && _vm.$abs.row.premail != '') ? _c('div', [_c('div', {
    staticClass: "row pad help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.affiliazioniHelp)
    }
  })]), _vm._v(" "), _c('absAffiliazioni')], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.autoriSection)
    }
  }), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('div', [_c('div', {
    staticClass: "row help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.autoriHelp)
    }
  })]), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('absAutori') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.paSection)
    }
  }), _vm._v(" "), (_vm.$teras.autori.length > 0) ? _c('absPrimoautore') : _vm._e(), _vm._v(" "), (_vm.$teras.evento.poster == 1 || _vm.$teras.evento.comunicazione == 1) ? _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.datiabsSection)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$abs.row.paemail != '' && _vm.$abs.row.pacellulare != '') ? _c('absPoster') : _vm._e(), _vm._v(" "), (_vm.$teras.evento.finanziamenti == 1) ? _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.finanziamentiSection)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.finanziamenti == 1 && _vm.$abs.row.paemail != '' && _vm.$abs.row.pacellulare != '') ? _c('absFinanziamenti') : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.testoSection)
    }
  }), _vm._v(" "), (_vm.$abs.row.paemail != '' && _vm.$abs.row.pacellulare != '') ? _c('absTesto') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewSection)
    }
  }), _vm._v(" "), (_vm.$abs.row.wordcount > 1 && _vm.$abs.row.wordcount < _vm.$teras.evento.maxparole + 1) ? _c('div', [(!_vm.$teras.preview) ? _c('div', {
    staticClass: "row pad help"
  }, [_c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])]), _vm._v(" "), _c('div', {
    staticClass: "col s10"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewHelp)
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "16px 0 0 0",
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onPreview
    }
  }, [_vm._v("Preview")])], 1)]) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "linkPreview",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "href": _vm.urlPreview,
      "target": "_blank"
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "row pad"
  }, [_c('div', {
    staticClass: "col s12 m4"
  }, [(_vm.$teras.preview) ? _c('div', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0 20px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewCheckHelp)
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.preview),
      callback: function($$v) {
        _vm.preview = $$v
      },
      expression: "preview"
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.previewCheck))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.onChange
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.modifica))])], 1) : _vm._e(), _vm._v(" "), (_vm.preview > 0) ? _c('div', {
    staticStyle: {
      "margin": "80px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 0 20px 0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.previewCheckedHelp)
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Save
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.salvainvia))])], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.preview && _vm.$abs.row.step == 1) ? _c('div', {
    staticStyle: {
      "margin": "80px 0"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveNoEmail
    }
  }, [_vm._v("SALVA SENZA INVIARE EMAIL")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m8"
  }, [(_vm.$teras.preview) ? _c('el-pdf', {
    attrs: {
      "pdfPath": _vm.$abs.urlPreview
    }
  }) : _vm._e()], 1)])]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside-in",
    domProps: {
      "innerHTML": _vm._s(_vm.page)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside-in",
    domProps: {
      "innerHTML": _vm._s(_vm.page)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pad-in"
  }, [(_vm.file.url == '') ? _c('el-upload', {
    ref: "uploadFiles",
    staticClass: "col s12",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "action": _vm.action,
      "file-list": _vm.fileList,
      "multiple": false,
      "drag": "",
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-exceed": _vm.onExceed,
      "before-upload": _vm.beforeUpload,
      "data": {
        dir: _vm.savedir,
        scriptError: '504 Errore lato server'
      },
      "headers": {
        'X-Request-ID': this.$teras.name,
        'X-aes': false
      },
      "show-file-list": false
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "yo-valign-center"
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "4.8rem"
    }
  }, [_vm._v("cloud_upload")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_vm._v("Drop file document here or "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("click to upload")])])])])]) : _vm._e(), _vm._v(" "), (_vm.file.url != '') ? _c('div', {
    staticClass: "col s12",
    staticStyle: {
      "height": "100px",
      "border": "1px dashed lightgrey",
      "margin-bottom": "10px"
    }
  }, [(_vm.file.url != '') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "10px 0 0 0"
    }
  }, [_c('div', {
    staticClass: "col s12 yo-align-right"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "alert"
    },
    on: {
      "click": function($event) {
        _vm.docfile = ''
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 yo-align-center"
  }, [_c('a', {
    staticClass: "yo-button yo-text-s",
    attrs: {
      "href": _vm.previewurl + _vm.file.url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cloud_download")]), _c('br'), _vm._v(_vm._s(_vm.file.name) + "\n         ")])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-footer"
  }, [_c('div', {
    staticClass: "row pad"
  }, [_c('div', {
    staticClass: "col s12 m5m offset-mm"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$teras.bvent.titolo))]), _vm._v("\n            " + _vm._s(_vm.$teras.bvent.citta) + ", " + _vm._s(_vm._f("data")(_vm.$teras.bvent.iniziail, 'D MMMM')) + " - " + _vm._s(_vm._f("data")(_vm.$teras.bvent.finisceil, 'LL')) + "\n            "), _c('div', {
    staticStyle: {
      "margin": "20px 0 0 0"
    }
  }, [_vm._v("security: " + _vm._s(_vm.axios.sessionID) + "·" + _vm._s(_vm.$abs.row.evento) + "·" + _vm._s(_vm.$teras.version))])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.assistenzaSection)
    }
  }), _vm._v(" "), (_vm.$teras.evento.id == 136) ? _c('div', [_vm._v("\n                    Per ricevere assistenza potete contattare \n                    "), _c('br'), _vm._v("\n                    I VIAGGI DI SALOMONE-ASCO SRL\n                    "), _c('br'), _vm._v("\n                    Email "), _c('a', {
    attrs: {
      "href": "'mailto:sisvet2024@iviaggidisalomone.it'"
    }
  }, [_vm._v("sisvet2024@iviaggidisalomone.it")])]) : _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.assistenzaHelp)
    }
  }), _vm._v("\n                " + _vm._s(_vm.$teras.evento.responsabile) + "\n                "), _c('br'), _vm._v("\n                Email "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.$teras.evento.responsabileemail
    }
  }, [_vm._v(_vm._s(_vm.$teras.evento.responsabileemail))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-pa"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cognome,
      "prop": "prcognome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.prcognome),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "prcognome", $$v)
      },
      expression: "$abs.row.prcognome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.nome,
      "prop": "prnome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.prnome),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "prnome", $$v)
      },
      expression: "$abs.row.prnome"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.email,
      "prop": "premail"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.premail),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "premail", $$v)
      },
      expression: "$abs.row.premail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cellulare
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.prcellulare),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "prcellulare", $$v)
      },
      expression: "$abs.row.prcellulare"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m10 offset-m2"
  }, [_c('h4', {
    staticClass: "yo-color-secondary"
  }, [_vm._v(_vm._s(_vm.$teras.lang.privacyTitle))]), _vm._v(" "), (_vm.$teras.language == 'it') ? _c('div', [_vm._v("\n  Si prega di prendere visione dell'Informativa sul Trattamento dei Dati "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://bvent.biomedia.net/gdpr/privacy-ABSTRACT' + (_vm.$teras.evento.id == 136 ? '-' + _vm.$teras.evento.id : '') + '.pdf'
    }
  }, [_vm._v("cliccando qui")])]) : _vm._e(), _vm._v(" "), (_vm.$teras.language == 'en') ? _c('div', [_vm._v("\n  Please "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://bvent.biomedia.net/gdpr/privacy-ABSTRACT-en.pdf"
    }
  }, [_vm._v("view")]), _vm._v(" Privacy Policy\n  ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$abs.row.pa > -1) ? _c('div', {
    staticClass: "abs-testo"
  }, [_c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.finanziamentiLabel,
      "prop": "finanziamenti"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.finanziamentiChange
    },
    model: {
      value: (_vm.finanziamenti),
      callback: function($$v) {
        _vm.finanziamenti = $$v
      },
      expression: "finanziamenti"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1), _vm._v(" "), ((_vm.finanziamenti == 1 && typeof _vm.$teras.evento.tipoeditor != 'undefined')) ? _c('el-form-item', {
    attrs: {
      "label": "Specificare quale"
    }
  }, [_c('tinymce', {
    attrs: {
      "initvalue": _vm.$abs.row.finanziamenti,
      "height": "300",
      "language": _vm.$teras.language
    },
    model: {
      value: (_vm.$abs.row.finanziamenti),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "finanziamenti", $$v)
      },
      expression: "$abs.row.finanziamenti"
    }
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pad header-fixed site-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s1m yo-align-right"
  }, [(_vm.$teras.language == 'it') ? _c('img', {
    attrs: {
      "src": __webpack_require__(571)
    },
    on: {
      "click": function($event) {
        return _vm.changeLang('en')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$teras.language == 'en') ? _c('img', {
    attrs: {
      "src": __webpack_require__(572)
    },
    on: {
      "click": function($event) {
        return _vm.changeLang('it')
      }
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s9m offset-sm"
  }, [_vm._v("BIOMEDIA "), _c('span', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v("PIATTAFORMA ABSTRACT")])])
}]}

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('router-link', {
    attrs: {
      "to": "/abs-new"
    }
  }, [_vm._v("Nuovo Abstract")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-pa"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.paName
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.pa),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pa", $$v)
      },
      expression: "$abs.row.pa"
    }
  }, _vm._l((_vm.$teras.autori), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.cognome + ' ' + item.nome,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.email,
      "prop": "paemail"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.paemail),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "paemail", $$v)
      },
      expression: "$abs.row.paemail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cellulare,
      "prop": "pacellulare"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.pacellulare),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pacellulare", $$v)
      },
      expression: "$abs.row.pacellulare"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.$teras.evento.pacodicefiscale == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.codicefiscale,
      "prop": "pacodicefiscale"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.$abs.row.pacodicefiscale),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pacodicefiscale", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "$abs.row.pacodicefiscale"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.panato == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.annonascita,
      "prop": "panato"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.panato),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "panato", $$v)
      },
      expression: "$abs.row.panato"
    }
  }, _vm._l((_vm.annonascita), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.pacategoriaprofessionale == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.categoriaprofessionale,
      "prop": "pacategoriaprofessionale"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.pacategoriaprofessionale),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "pacategoriaprofessionale", $$v)
      },
      expression: "$abs.row.pacategoriaprofessionale"
    }
  }, _vm._l((_vm.$teras.categoriaprofessionale), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.paregionelavoro == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.regionelavoro,
      "prop": "paregionelavoro"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.paregionelavoro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "paregionelavoro", $$v)
      },
      expression: "$abs.row.paregionelavoro"
    }
  }, _vm._l((_vm.$teras.regione), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.panazionelavoro == 1) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.nazionelavoro,
      "prop": "panazionelavoro"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.panazionelavoro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "panazionelavoro", $$v)
      },
      expression: "$abs.row.panazionelavoro"
    }
  }, _vm._l((_vm.$teras.nazione), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.paassociazione != '') ? _c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.socio,
      "prop": "paassociazione"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.paassociazione),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "paassociazione", $$v)
      },
      expression: "$abs.row.paassociazione"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Non socio",
      "value": -1
    }
  }), _vm._v(" "), _vm._l((_vm.$teras.associazioni), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item['nome_' + _vm.$teras.language],
        "value": item.id
      }
    })
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._v("\n\nSiamo spiacenti il gestionale è chiuso. \n\n\n\n\n")])
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    attrs: {
      "id": _vm.thisId
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('router-link', {
    attrs: {
      "to": "/abs-new"
    }
  }, [_vm._v("Nuovo Abstract")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-affiliazioni"
  }, [_c('div', {
    staticClass: "row"
  }, [(false) ? _c('div', {
    staticClass: "col s3"
  }, [_c('el-form-item', [_c('el-input', {
    model: {
      value: (_vm.affiliazione.id),
      callback: function($$v) {
        _vm.$set(_vm.affiliazione, "id", $$v)
      },
      expression: "affiliazione.id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s10"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.affiliazione
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.affiliazione.nome),
      callback: function($$v) {
        _vm.$set(_vm.affiliazione, "nome", $$v)
      },
      expression: "affiliazione.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [(_vm.affiliazione.id == -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.aggiungi,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.affiliazione.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.salvamodifiche,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "edit"
    },
    on: {
      "click": _vm.editNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.affiliazione.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.cancella,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete"
    },
    on: {
      "click": _vm.delNow
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('div', {
    staticClass: "row pad help"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.affiliazioniOrderHelp)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$teras.affiliazioni.length > 0) ? _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "list": _vm.$teras.affiliazioni
    },
    on: {
      "end": _vm.onEnd
    }
  }, _vm._l((_vm.$teras.affiliazioni), function(element, index) {
    return _c('div', {
      key: element.id,
      on: {
        "click": function($event) {
          return _vm.onEdit(element)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + " " + _vm._s(element.nome))])
  }), 0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])])
}]}

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-autori"
  }, [_c('div', {
    staticClass: "row"
  }, [(false) ? _c('div', {
    staticClass: "col s3"
  }, [_c('el-form-item', [_c('el-input', {
    model: {
      value: (_vm.autore.id),
      callback: function($$v) {
        _vm.$set(_vm.autore, "id", $$v)
      },
      expression: "autore.id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cognome
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.autore.cognome),
      callback: function($$v) {
        _vm.$set(_vm.autore, "cognome", $$v)
      },
      expression: "autore.cognome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.nome
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.autore.nome),
      callback: function($$v) {
        _vm.$set(_vm.autore, "nome", $$v)
      },
      expression: "autore.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s10"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.affiliazione
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.autore.affiliazione),
      callback: function($$v) {
        _vm.$set(_vm.autore, "affiliazione", $$v)
      },
      expression: "autore.affiliazione"
    }
  }, _vm._l((_vm.$teras.affiliazioni), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [(_vm.autore.id == -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.aggiungi,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autore.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.salvamodifiche,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "edit"
    },
    on: {
      "click": _vm.editNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autore.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.cancella,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete"
    },
    on: {
      "click": _vm.delNow
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.$teras.autori.length > 0) ? _c('div', {
    staticClass: "row pad help"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.autoriOrderHelp)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$teras.autori.length > 0) ? _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "list": _vm.$teras.autori
    },
    on: {
      "end": _vm.onEnd
    }
  }, _vm._l((_vm.$teras.autori), function(element, index) {
    return _c('div', {
      key: element.id,
      on: {
        "click": function($event) {
          return _vm.onEdit(element)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + " " + _vm._s(element.cognome) + " " + _vm._s(element.nome) + " "), _c('sup', [_vm._v(_vm._s(_vm.affiliazione(element.affiliazione)))])])
  }), 0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])])
}]}

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    attrs: {
      "id": _vm.thisId
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    attrs: {
      "id": _vm.thisId
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (!_vm.$teras.appReady),
      expression: "!$teras.appReady",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "app"
    }
  }, [_c('site-header'), _vm._v(" "), (_vm.$teras.appReady) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "padding": "62px 20px 0 20px"
    }
  }, [_c('div', {
    staticClass: "evento-title yo-color-primary"
  }, [_vm._v(_vm._s(_vm.$teras.bvent.titolo) + ": ABSTRACT")])]) : _vm._e(), _vm._v(" "), (_vm.$teras.appReady) ? _c('div', {
    staticClass: "row container",
    staticStyle: {
      "background": "#ffffff",
      "padding": "0 20px 60px 20px"
    }
  }, [_c('div', {
    staticClass: "col s12",
    attrs: {
      "id": "main"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "main"
    }
  }), _vm._v(" "), (_vm.$teras.chiuso) ? _c('h4', [_vm._v("Siamo spiacenti il gestionale è chiuso. ")]) : _vm._e(), _vm._v(" "), (_vm.$teras.noabstract) ? _c('h4', [_vm._v("Abstract non trovato.")]) : _vm._e(), _vm._v(" "), (_vm.$teras.noevento) ? _c('h4', [_vm._v("Evento non trovato.")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.$teras.appReady) ? _c('site-footer') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-poster"
  }, [(_vm.$teras.evento.poster == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsPoster,
      "prop": "poster"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.poster),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "poster", $$v)
      },
      expression: "$abs.row.poster"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (((_vm.$teras.evento.poster == 1 && _vm.$abs.row.poster == 1) || _vm.$teras.evento.poster == 2) && _vm.$teras.topicposter.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic",
      "prop": "topicposter"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$teras.lang.scegliere_lista
    },
    model: {
      value: (_vm.$abs.row.topicposter),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topicposter", $$v)
      },
      expression: "$abs.row.topicposter"
    }
  }, _vm._l((_vm.$teras.topicposter), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.id == 136 && _vm.$abs.row.poster == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Partecipi al Premio della Fondazione?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.comunicazione == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsOrale,
      "prop": "comunicazione"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.comunicazione),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "comunicazione", $$v)
      },
      expression: "$abs.row.comunicazione"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (((_vm.$teras.evento.comunicazione == 1 && _vm.$abs.row.comunicazione == 1) || _vm.$teras.evento.comunicazione == 2) && _vm.$teras.topiccomunicazione.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic",
      "prop": "topiccomunicazione"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.$abs.row.topiccomunicazione),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topiccomunicazione", $$v)
      },
      expression: "$abs.row.topiccomunicazione"
    }
  }, _vm._l((_vm.$teras.topiccomunicazione), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.poster == 3 && _vm.$abs.row.comunicazione == '0') ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsPoster,
      "prop": "poster"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.poster),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "poster", $$v)
      },
      expression: "$abs.row.poster"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.poster == 3 && _vm.$abs.row.poster == 1 && _vm.$abs.row.comunicazione == '0' && _vm.$teras.topicposter.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic",
      "prop": "topicposter"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$teras.lang.scegliere_lista
    },
    model: {
      value: (_vm.$abs.row.topicposter),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topicposter", $$v)
      },
      expression: "$abs.row.topicposter"
    }
  }, _vm._l((_vm.$teras.topicposter), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.posterdopocomunicazione == 1 && _vm.$abs.row.comunicazione == 1) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": _vm.$teras.lang.datiabsPosterNoOrale,
      "prop": "posterdopocomunicazione"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.poster),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "poster", $$v)
      },
      expression: "$abs.row.poster"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.posterdopocomunicazione == 1 && _vm.$abs.row.comunicazione == 1 && _vm.$abs.row.poster == 1 && _vm.$teras.topicposter.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Topic ",
      "prop": "topicposter"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$teras.lang.scegliere_lista
    },
    model: {
      value: (_vm.$abs.row.topicposter),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "topicposter", $$v)
      },
      expression: "$abs.row.topicposter"
    }
  }, _vm._l((_vm.$teras.topicposter), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.topicposter == 11 && _vm.$abs.row.comunicazione == 0) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desidera partecipare all'assegnazione del premio Binding Site?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 41 && _vm.$abs.row.comunicazione == 0) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desidera partecipare all'assegnazione del premio Binding Site?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 84) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 98) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - SECONDA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 131) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - TERZA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 149) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - QUARTA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 172) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Vuoi partecipare all'assegnazione del PREMIO SEBIA ITALIA AWARD - QUINTA EDIZIONE?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$abs.row.evento == 177) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desideri partecipare all'assegnazione dei Premi?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$teras.evento.id == 14) ? _c('el-form-item', {
    staticClass: "yesno-label",
    attrs: {
      "label": "Desidera concorrere ai premi previsti per il congresso?",
      "prop": "dmdaltro"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.$abs.row.dmdaltro),
      callback: function($$v) {
        _vm.$set(_vm.$abs.row, "dmdaltro", $$v)
      },
      expression: "$abs.row.dmdaltro"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 0
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.no))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.si))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hammer-up"
  }, [_c('div', {
    ref: "hammer",
    staticClass: "hammer"
  }, [_c('canvas', {
    ref: "hammerIn",
    attrs: {
      "tag": "canvas",
      "id": "theCanvas"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isButton),
      expression: "isButton"
    }],
    staticClass: "pdf-button"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currPageNumber,
      "page-size": 1,
      "layout": "prev, pager, next",
      "total": _vm.doc.numPages
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    staticStyle: {
      "min-height": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n  Le chiediamo di inserire il codice di consultazione del suo abstract. \n  ")]), _vm._v(" "), _c('el-form', {
    ref: "isAbs",
    attrs: {
      "model": _vm.abs,
      "rules": _vm.rules,
      "label-width": "180px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onConsulta.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.codiceconsultazione,
      "prop": "codiceconsultazione"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.abs.codiceconsultazione),
      callback: function($$v) {
        _vm.$set(_vm.abs, "codiceconsultazione", $$v)
      },
      expression: "abs.codiceconsultazione"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "col s12 m3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConsulta
    }
  }, [_vm._v("Procedi")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 m3"
  })])], 1), _vm._v(" "), (_vm.esito) ? _c('div', [_c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.esito)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-navbar"
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "1",
      "mode": "horizontal",
      "router": true
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "a"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Informazioni Generali")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/citta"
    }
  }, [_vm._v("Città di Napoli")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/sede"
    }
  }, [_vm._v("Sede del congresso")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/premi"
    }
  }, [_vm._v("Premi")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/ecm"
    }
  }, [_vm._v("ECM")])], 2), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "b"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Iscrizioni")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/info-generali/quote"
    }
  }, [_vm._v("Modalità di iscrizione")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/comitati/comitati"
    }
  }, [_vm._v("Comitati")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "c"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Programma")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-c",
    attrs: {
      "index": "/inside/programma/presto-disponibile"
    }
  }, [_vm._v("Presto disponibile")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/abstract/abstract"
    }
  }, [_vm._v("Abstract")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/inside/info-generali/prenotazione-alberghiera"
    }
  }, [_vm._v("Prenotazione Alberghiera")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "f"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Aziende")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "/inside/aziende/sponsor"
    }
  }, [_vm._v("Sponsor")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "font-color-e",
    attrs: {
      "index": "iscrizioni"
    }
  }, [_vm._v("Iscrizioni")])], 2)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._v("\n\n" + _vm._s(_vm.$teras.lang.inviatoText) + " \n\n\n "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "col s12 m3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onNew
    }
  }, [_vm._v(_vm._s(_vm.$teras.lang.inviatoButton) + " ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 m3"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hammer-up"
  }, [_c('div', {
    ref: "hammer",
    staticClass: "hammer"
  }, [_c('canvas', {
    ref: "hammerIn",
    attrs: {
      "tag": "canvas",
      "id": "theCanvas"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isButton),
      expression: "isButton"
    }],
    staticClass: "pdf-button"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currPageNumber,
      "page-size": 1,
      "layout": "prev, pager, next",
      "total": _vm.doc.numPages
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Abs-affiliazioni.vue": 292,
	"./Abs-autori.vue": 293,
	"./Abs-consulta.vue": 578,
	"./Abs-finanziamenti.vue": 294,
	"./Abs-new.vue": 579,
	"./Abs-poster.vue": 295,
	"./Abs-presentatore.vue": 296,
	"./Abs-primoautore.vue": 297,
	"./Abs-testo.vue": 298,
	"./Abs-tinymce.vue": 580,
	"./Chiuso.vue": 581,
	"./Hello.vue": 582,
	"./Home.vue": 583,
	"./Inside.vue": 584,
	"./Inviato.vue": 585,
	"./Page-tinymce.vue": 92,
	"./Pdf-desktop.vue": 299,
	"./Pdf.vue": 586,
	"./Site-footer.vue": 300,
	"./Site-header.vue": 301,
	"./Site-navbar.vue": 587,
	"./Tinymce.vue": 588,
	"./Upload.vue": 302,
	"./_Home.vue": 589,
	"./_Inside.vue": 590,
	"./_Tinymce.vue": 591
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 627:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__teras__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aes__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);










var tAxios = function (_Axios) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(tAxios, _Axios);

    function tAxios(args) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, tAxios);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (tAxios.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(tAxios)).call(this, {
            withCredentials: true,
            validateStatus: function validateStatus(status) {
                return status >= 200 && status < 300 && status != 210;
            },
            transformResponse: [function (data) {
                if (typeof data === 'string') {
                    if (_this.aes) data = JSON.parse(__WEBPACK_IMPORTED_MODULE_7__aes__["a" /* default */].decode(data));
                    data = JSON.parse(data);
                }
                return data;
            }]
        }));

        console.log(_this);
        _this.apiUrl = 'https://api.biomedia.net/201706/';
        _this.aes =  true ? 1 : 0;
        _this.defaults.headers = { 'X-Request-ID': __WEBPACK_IMPORTED_MODULE_6__teras__["a" /* default */].name, 'X-aes': _this.aes };
        _this.sessionID = '';
        _this.mysql = {
            composer: 'db',
            db: { database: 'bm_bams' }
        };
        _this.sessionInterval = setInterval(function () {
            _this.get(_this.apiUrl + 'vue/updatesession/');
        }, 120000);
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(tAxios, [{
        key: 'sessionGet',
        value: function sessionGet(key) {
            return this.post(this.apiUrl + 'vue/sessionget', { key: key }).then(function (response) {
                return response.data.data;
            });
        }
    }, {
        key: 'sessionSet',
        value: function sessionSet(key, value) {
            return this.post(this.apiUrl + 'vue/sessionset', { key: key, value: value }).then(function (response) {
                console.log("SETTATO SESSION KEY");
                console.log(response.data.data);
                return response.data.data;
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            this.get(this.apiUrl + 'vue/logout');
        }
    }, {
        key: 'query',
        value: function query(fetch, _query, params) {
            var mySql = {
                db: this.mysql.db,
                sqlFetch: fetch,
                sqlQuery: _query,
                sqlParams: params
            };
            var argumentsLength = arguments.length;
            if (arguments.length > 3) var param2set = arguments[3];
            if (arguments.length > 4) var key2set = arguments[4];

            console.log(arguments);

            return this.post(this.apiUrl + this.mysql.composer + '/query', mySql).then(function (response) {
                var api = response.data;
                console.log("ARRIVO A VERIFICARE SE SETTARE LA VARIABILE");
                console.log(typeof param2set === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(param2set));
                console.log("TYPEOF " + argumentsLength + " " + key2set);
                console.log(api);
                if (argumentsLength > 3 && typeof param2set != 'undefined') {
                    console.log("TROVATA LA VARIABILE");
                    if (typeof key2set != 'undefined') {
                        param2set[key2set] = api.data.result;
                    } else {
                        param2set = api.data.result;
                    }
                }
                console.log(api.data);
                return api.data;
            }).catch(function (error) {
                console.log("ERROR AL QUERY");
                console.log(error);
                return error;
            });
        }
    }, {
        key: 'insertRows',
        value: function insertRows(rows, table) {
            var mySql = {
                db: this.mysql.db,
                table: table,
                rows: rows
            };
            return this.post(this.apiUrl + this.mysql.composer + '/insertrows', mySql).then(function (response) {
                return response.data;
            }).catch(function (error) {
                console.log("ERROR AL QUERY");
                console.log(error);
                return error;
            });
        }
    }]);

    return tAxios;
}(__WEBPACK_IMPORTED_MODULE_8_axios__["Axios"]);

/* harmony default export */ __webpack_exports__["a"] = (new tAxios());

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[386]);


// WEBPACK FOOTER //
// static/js/app.528b5a575981adbd7a93.js